import { AuthStatus, BaseReadsProvider, BaseTransactor, BaseWritesContext, BaseWritesProvider, BlockchainTransactionType, CreateSpaceFlowStatus, HOUR_MS, InstalledAppsUpdater, JoinFlowStatus, MINUTE_MS, MembershipAlreadyMemberError, MembershipRejectedError, NULL_ADDRESS, QueryProvider, SECOND_MS, SignerUndefinedError, SpaceContext, SpaceContextProvider, TownsContext, TownsContextProvider, TransactionStatus, UserLookupContext, WalletDoesNotMatchSignedInAccountError, WalletStatus, addCategoryToError, addCategoryToErrorIfNotExists, blockchainKeys, bustMembershipStatus, createBaseReadsContext, createBotDataQueryOptions, createTransactionContext, defaultStaleTime, fetchGuardianStatus, fetchMembershipStatus, generateOfflineUserKey, getAppExpiration, getBannedWalletAddresses, getChainName, getChannelPermissionOverrides, getChannelSettings, getChannelSettingsQueryData, getErrorCategory, getInstalledApps, getMembershipFreeAllocation, getMembershipInfo, getMembershipInfoQueryData, getMembershipPrice, getMultipleRoleDetails, getPermissionsByRoleId, getPlatformMembershipFee, getPlatformMembershipFeeFromQueryCache, getPlatformMinMembershipPrice, getPlatformMinMembershipPriceFromQueryCache, getPlatformMintLimit, getPricingModuleQueryData, getPricingModules, getProtocolFee, getRiverPoints, getRoleDetails, getRoleDetailsQueryData, getRoles, getRootKeyFromLinkedWalletCached, getSafeOfflineMembershipStatus, getSingleSubscription, getSpaceDelegationOperator, getSpaceDelegationsByOperator, getSpaceInfo, getSpaceInfoQueryData, getSpaceOwner, getSpaceTips, getStakingDepositDetails, getStakingDepositsByOwner, getStakingRewards, getSubscriptions, getSwapsPaginated, getTokenIdOfOwner, getTownsTokenBalance, invalidateGuardianStatus, invalidateHasPermissionQueriesForSpace, invalidateSpaceInfoQuery, invalidateSpaceOwner, invariant, isDefined, isMembershipExpired, isNullAddress, makeProviderFromChain, makeProviderFromConfig, primaryWalletStore, queryClient, queryOptions, retryOperation, skipErrorDecoding, sleep, sleepUntil, staleTime24Hours, staticAssertNever, toError, useBannedWalletAddresses, useBaseReads, useBaseWrites, useBotData, useCasablancaCredentials, useCasablancaStore, useCasablancaStream, useChannelSettings, useConnectivity, useContractSpaceInfo, useContractSpaceInfoWithoutClient, useDefaultOwnershipCooldown, useFetchHasJoinPermission, useGetRootKeyFromLinkedWallet, useGetSingleSubscription, useGetSubscriptions, useGuardianStatus, useHasPermission, useImageStore, useInstalledApps, useIsSpaceOwner, useLinkSmartAccountAndEOAAndSetDefaultWallet, useLinkedAndDelegatedWallets, useMembershipFreeAllocation, useMembershipInfo, useMembershipInfoWithPricingModule, useMembershipPrice, useMembershipRenewalPrice, useMembershipStatus, useMultipleMembershipStatus, useMultipleRoleDetails, useMutation, useMyLinkedWallets, useMyWallets, useNetworkStatus, useObservable, useObservableWith, useOfflineStore, useOnHasPermissionQueryUpdate, usePermissionOverrides, usePlatformMembershipFee, usePlatformMembershipPriceForSupplyInEth, usePlatformMinMembershipPrice, usePlatformMintLimit, usePrefetchMultipleRoleDetails, usePricingModules, usePrimaryWallet, useProtocolFee, useQueries, useQuery, useQueryClient, useReadAppExpiration, useRiverPointsDetails, useRoleDetails, useRoles, useSetPrimaryWallet, useSpaceContext, useSpaceData, useSpaceDataStore, useSpaceDataWithId, useSpaceDelegationOperator, useSpaceDelegationsByOperator, useSpaceId, useSpaceThreadRoots, useSpaceThreadRootsUnreadCount, useSpaceTips, useSpacesIds, useSpacesIdsFrom, useStakingDepositDetailsQueries, useStakingDepositsByOwnerQuery, useStakingRewardsQuery, useStreamMetadataUpdater, useTokenIdOfOwner, useTownsClient, useTownsContext, useTownsTokenBalance, useTransaction, useUserLookupStore, userLookupFn } from "./TownsContextProvider-Crse5qmy.js";
import { DmChannelSettingValue, GdmChannelSettingValue, MembershipOp, SpaceChannelSettingValue } from "@towns-protocol/proto";
import { Membership, MessageType, Observable, RiverTimelineEvent, TimelinesView, getMutedChannelIds, isChannelStreamId, isDMChannelStreamId, isGDMChannelStreamId, isSpaceStreamId, isUserStreamId, isValidStreamId, makeAppRegistryRpcClient, spaceIdFromChannelId, streamIdAsBytes, streamIdAsString, toEvent, unpackMiniblock, userIdFromAddress } from "@towns-protocol/sdk";
import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { ETH_ADDRESS, ITippingShim, SpaceAddressFromSpaceId, SpaceIdFromSpaceAddress, convertRuleDataV2ToV1, getDefaultXChainIds } from "@towns-protocol/web3";
import { bin_fromHexString } from "@towns-protocol/utils";
import { queryOptions as queryOptions$1, useQueries as useQueries$1, useQuery as useQuery$1, useQueryClient as useQueryClient$1 } from "@tanstack/react-query";
import { ethers } from "ethers";
import { gql, request } from "graphql-request";
import { decodeAbiParameters, erc20Abi, parseUnits, zeroAddress } from "viem";
import { isEqual, memoize } from "lodash-es";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { jsx, jsxs } from "react/jsx-runtime";
import { activateSubscription, installSubscription, migrateSubscriptionCurrency, pauseSubscription } from "@towns/userops";
import { encryptAesGcm, exportAesGsmKeyBytes, generateNewAesGcmKey } from "@towns-protocol/encryption";
import { Marked } from "marked";
import markedPlaintify from "marked-plaintify";
import { ISwapRouter__factory } from "@towns-protocol/generated/dev/typings/factories/ISwapRouter__factory";
import { z } from "zod";

export * from "@towns-protocol/web3"

//#region src/client/TownsNotifciationSettings.ts
const EMPTY_NOTIFICATIONS_OBSERVABLE = new Observable({
	fetchedAtMs: void 0,
	settings: void 0,
	error: void 0
});
function useNotificationSettingsData() {
	const { casablancaClient } = useTownsContext();
	const observable = casablancaClient?.streamsView.notificationSettings ?? EMPTY_NOTIFICATIONS_OBSERVABLE;
	const data = useObservable(observable);
	return { notificationSettings: data };
}
function useNotificationSettings() {
	const { casablancaClient } = useTownsContext();
	const client = casablancaClient?.notifications;
	useEffect(() => {
		if (client && (!client.notificationSettings.fetchedAtMs || client.notificationSettings.fetchedAtMs < Date.now() - 1e3 * 60 * 60 * 5)) client?.getSettings();
	}, [client]);
	const observable = casablancaClient?.streamsView.notificationSettings ?? EMPTY_NOTIFICATIONS_OBSERVABLE;
	const data = useObservable(observable);
	const getSpaceSetting = useCallback((spaceId) => {
		const spaceSettings = data.settings?.space.find((s) => streamIdAsString(s.spaceId) === spaceId);
		if (spaceSettings && spaceSettings.value !== SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_UNSPECIFIED) return spaceSettings.value;
		return SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_ONLY_MENTIONS_REPLIES_REACTIONS;
	}, [data.settings?.space]);
	const getChannelSetting = useCallback((channelId) => {
		const spaceId = spaceIdFromChannelId(channelId);
		const spaceSetting = data.settings?.space.find((s) => streamIdAsString(s.spaceId) === spaceId);
		if (spaceSetting) {
			const channelSetting = spaceSetting.channels.find((c) => streamIdAsString(c.channelId) === channelId);
			if (channelSetting && channelSetting.value !== SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_UNSPECIFIED) return channelSetting.value;
			if (spaceSetting.value !== SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_UNSPECIFIED) return spaceSetting.value;
		}
		return SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_ONLY_MENTIONS_REPLIES_REACTIONS;
	}, [data.settings?.space]);
	const getRawChannelSetting = useCallback((channelId) => {
		const spaceId = spaceIdFromChannelId(channelId);
		const spaceSetting = data.settings?.space.find((s) => streamIdAsString(s.spaceId) === spaceId);
		if (spaceSetting) {
			const channelSetting = spaceSetting.channels.find((c) => streamIdAsString(c.channelId) === channelId);
			if (channelSetting) return channelSetting.value;
		}
		return SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_UNSPECIFIED;
	}, [data.settings]);
	const getDmGlobalSetting = useCallback(() => {
		if (data.settings && data.settings.dmGlobal !== DmChannelSettingValue.DM_UNSPECIFIED) return data.settings?.dmGlobal;
		return DmChannelSettingValue.DM_MESSAGES_YES;
	}, [data.settings]);
	const getDmSetting = useCallback((channelId) => {
		const dmSetting = data.settings?.dmChannels.find((c) => streamIdAsString(c.channelId) === channelId);
		if (dmSetting && dmSetting.value !== DmChannelSettingValue.DM_UNSPECIFIED) return dmSetting.value;
		if (data.settings && data.settings?.dmGlobal !== DmChannelSettingValue.DM_UNSPECIFIED) return data.settings.dmGlobal;
		return DmChannelSettingValue.DM_MESSAGES_YES;
	}, [data.settings]);
	const getRawDmSetting = useCallback((channelId) => {
		const dmSetting = data.settings?.dmChannels.find((c) => streamIdAsString(c.channelId) === channelId);
		return dmSetting?.value ?? DmChannelSettingValue.DM_UNSPECIFIED;
	}, [data.settings]);
	const getGdmGlobalSetting = useCallback(() => {
		if (data.settings && data.settings.gdmGlobal !== GdmChannelSettingValue.GDM_UNSPECIFIED) return data.settings?.gdmGlobal;
		return GdmChannelSettingValue.GDM_MESSAGES_ALL;
	}, [data.settings]);
	const getGdmSetting = useCallback((channelId) => {
		const gdmSetting = data.settings?.gdmChannels.find((c) => streamIdAsString(c.channelId) === channelId);
		if (gdmSetting && gdmSetting.value !== GdmChannelSettingValue.GDM_UNSPECIFIED) return gdmSetting.value;
		if (data.settings && data.settings.gdmGlobal !== GdmChannelSettingValue.GDM_UNSPECIFIED) return data.settings.gdmGlobal;
		return GdmChannelSettingValue.GDM_MESSAGES_ALL;
	}, [data.settings]);
	const getRawGdmSetting = useCallback((channelId) => {
		const gdmSetting = data.settings?.gdmChannels.find((c) => streamIdAsString(c.channelId) === channelId);
		return gdmSetting?.value ?? GdmChannelSettingValue.GDM_UNSPECIFIED;
	}, [data.settings]);
	return {
		isLoading: !data.fetchedAtMs,
		error: data.error,
		notificationSettingsClient: client,
		settings: data.settings,
		getSpaceSetting,
		getChannelSetting,
		getRawChannelSetting,
		getDmSetting,
		getRawDmSetting,
		getGdmSetting,
		getRawGdmSetting,
		getDmGlobalSetting,
		getGdmGlobalSetting
	};
}
function useSpaceSettings(spaceId) {
	const { casablancaClient } = useTownsContext();
	const observable = casablancaClient?.streamsView.notificationSettings ?? EMPTY_NOTIFICATIONS_OBSERVABLE;
	return useObservableWith(observable, useCallback((state) => {
		const spaceSettings = state.settings?.space.find((s) => streamIdAsString(s.spaceId) === spaceId);
		if (spaceSettings && spaceSettings.value !== SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_UNSPECIFIED) return spaceSettings.value;
		return SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_ONLY_MENTIONS_REPLIES_REACTIONS;
	}, [spaceId]));
}
function useChannelSettings$1(channelId) {
	const { casablancaClient } = useTownsContext();
	const observable = casablancaClient?.streamsView.notificationSettings ?? EMPTY_NOTIFICATIONS_OBSERVABLE;
	return useObservableWith(observable, useCallback((state) => {
		const spaceId = spaceIdFromChannelId(channelId);
		const spaceSetting = state.settings?.space.find((s) => streamIdAsString(s.spaceId) === spaceId);
		if (spaceSetting) {
			const channelSetting = spaceSetting.channels.find((c) => streamIdAsString(c.channelId) === channelId);
			if (channelSetting && channelSetting.value !== SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_UNSPECIFIED) return channelSetting.value;
			if (spaceSetting.value !== SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_UNSPECIFIED) return spaceSetting.value;
		}
		return SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_ONLY_MENTIONS_REPLIES_REACTIONS;
	}, [channelId]));
}
function useDmSettings(channelId) {
	const { casablancaClient } = useTownsContext();
	const observable = casablancaClient?.streamsView.notificationSettings ?? EMPTY_NOTIFICATIONS_OBSERVABLE;
	return useObservableWith(observable, useCallback((state) => {
		const dmSetting = state.settings?.dmChannels.find((c) => streamIdAsString(c.channelId) === channelId);
		if (dmSetting && dmSetting.value !== DmChannelSettingValue.DM_UNSPECIFIED) return dmSetting.value;
		if (state.settings && state.settings.dmGlobal !== DmChannelSettingValue.DM_UNSPECIFIED) return state.settings.dmGlobal;
		return DmChannelSettingValue.DM_MESSAGES_YES;
	}, [channelId]));
}
function useGdmSettings(channelId) {
	const { casablancaClient } = useTownsContext();
	const observable = casablancaClient?.streamsView.notificationSettings ?? EMPTY_NOTIFICATIONS_OBSERVABLE;
	return useObservableWith(observable, useCallback((state) => {
		const gdmSetting = state.settings?.gdmChannels.find((c) => streamIdAsString(c.channelId) === channelId);
		if (gdmSetting && gdmSetting.value !== GdmChannelSettingValue.GDM_UNSPECIFIED) return gdmSetting.value;
		if (state.settings && state.settings.gdmGlobal !== GdmChannelSettingValue.GDM_UNSPECIFIED) return state.settings.gdmGlobal;
		return GdmChannelSettingValue.GDM_MESSAGES_ALL;
	}, [channelId]));
}
function useMutedStreamIds() {
	const { settings } = useNotificationSettings();
	return useMemo(() => {
		return getMutedChannelIds(settings) ?? new Set();
	}, [settings]);
}
function useMuteSettings({ spaceId, channelId }) {
	const spaceSettings = useSpaceSettings(spaceId ?? "");
	const dmSettings = useDmSettings(channelId ?? "");
	const gdmSettings = useGdmSettings(channelId ?? "");
	const channelSettings = useChannelSettings$1(channelId ?? "");
	return useMemo(() => {
		try {
			if (channelId && isDMChannelStreamId(channelId)) return {
				channelIsMuted: dmSettings === DmChannelSettingValue.DM_MESSAGES_NO_AND_MUTE,
				spaceIsMuted: false
			};
			else if (channelId && isGDMChannelStreamId(channelId)) return {
				channelIsMuted: gdmSettings === GdmChannelSettingValue.GDM_MESSAGES_NO_AND_MUTE,
				spaceIsMuted: false
			};
			return {
				channelIsMuted: channelId ? channelSettings === SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_NO_MESSAGES_AND_MUTE : false,
				spaceIsMuted: spaceId ? spaceSettings === SpaceChannelSettingValue.SPACE_CHANNEL_SETTING_NO_MESSAGES_AND_MUTE : false
			};
		} catch (error) {
			return {
				channelIsMuted: false,
				spaceIsMuted: false
			};
		}
	}, [
		channelId,
		channelSettings,
		dmSettings,
		gdmSettings,
		spaceId,
		spaceSettings
	]);
}

//#endregion
//#region src/components/ChannelContextProvider.tsx
const ChannelContext = createContext(void 0);
/**
* use instead of React.useContext, throws if not in a Provider
*/
function useChannelContext() {
	const context = useContext(ChannelContext);
	if (!context) throw new Error("useChannelContext must be used in a ChannelContextProvider");
	return context;
}
function ChannelContextProvider(props) {
	const { channelId } = props;
	const spaceId = useSpaceId();
	const channelContext = useMemo(() => ({
		channelId,
		spaceId
	}), [channelId, spaceId]);
	return /* @__PURE__ */ jsx(ChannelContext.Provider, {
		value: channelContext,
		children: props.children
	});
}

//#endregion
//#region src/components/UserLookupContextProviders.tsx
const DMChannelContextUserLookupProvider = ({ channelId, children, shouldFetchBots = true, abstractAccountAddress }) => {
	const { spaceId } = useSpaceContext();
	const contextValue = useMemo(() => ({
		spaceId,
		channelId
	}), [spaceId, channelId]);
	return /* @__PURE__ */ jsxs(UserLookupContext.Provider, {
		value: contextValue,
		children: [children, shouldFetchBots && channelId && /* @__PURE__ */ jsx(InstalledAppsUpdater, {
			context: "dm",
			channelId,
			abstractAccountAddress
		})]
	});
};

//#endregion
//#region src/hooks/use-user-lookup-context.ts
/**
* returns a function to imperatively lookup a user by userId within the scope of
* the current space or channel
*/
const useUserLookupContext = () => {
	const context = React.useContext(UserLookupContext);
	const spaceId = context?.spaceId;
	const channelId = context?.channelId;
	const genericLookupUser = useUserLookupStore((s) => s.lookupUser);
	const lookupUser = useCallback((userId) => genericLookupUser(userId, spaceId, channelId) ?? getStableDefault$1(userId), [
		genericLookupUser,
		spaceId,
		channelId
	]);
	return { lookupUser };
};
/**
* retrieve a user within scope of the current channel or space
*/
const useUserLookup = (userId) => {
	const { spaceId, channelId } = React.useContext(UserLookupContext) ?? {};
	return useUserLookupStore((s) => userLookupFn(s, userId, spaceId, channelId) ?? getStableDefault$1(userId));
};
/**
* based on a list of userIds, creates an array of users from the current channel
* or space
*
* tldr; when possible use useUserLookup() to focus on the updated user slice
*
* This is useful when you need to lookup multiple users as a whole (e.g a
* coma separated list of names that needs to re-rendered fully when any of the
* usernames changes)
*
* However if the elements of the list can be rendered
* as independent components it would be recommended to lookup each user slice individually to
* avoid full re-renders. @see useUserLookup()
*/
const useUserLookupArray = (userIds, streamId) => {
	let spaceId;
	let channelId;
	if (streamId) if (isChannelStreamId(streamId)) spaceId = spaceIdFromChannelId(streamId);
	else if (isSpaceStreamId(streamId)) spaceId = streamId;
	else channelId = streamId;
	return useUserLookupStore((s) => {
		return userIds.reduce((acc, userId) => {
			acc.push(userLookupFn(s, userId, spaceId, channelId) ?? getStableDefault$1(userId));
			return acc;
		}, []);
	});
};
/**
* based on a list of userIds, creates a map of users from the current channel
* or space
*
* tldr; when possible use useUserLookup() to focus on the updated user slice
*
* Similar to useUserLookupArray but more interesting if the list of userIds is
* prone to change frequently. With the map the lookup doesn't need to trigger
* an update because of the order or the ids changes
*/
const useUserLookupMap = (userIds) => {
	const { spaceId, channelId } = React.useContext(UserLookupContext) ?? {};
	return useUserLookupStore((s) => {
		return userIds.reduce((acc, userId) => acc.set(userId, userLookupFn(s, userId, spaceId, channelId) ?? getStableDefault$1(userId)), new Map());
	});
};
const getStableDefault$1 = memoize((userId) => ({
	userId,
	username: "",
	usernameConfirmed: false,
	usernameEncrypted: false,
	displayName: "",
	displayNameEncrypted: false
}), (userId) => userId);

//#endregion
//#region src/hooks/use-channel-data.ts
function useChannelData() {
	const { channelId, spaceId } = useChannelContext();
	const channel = useChannelWithSpaceId(channelId, spaceId);
	return useMemo(() => {
		return {
			spaceId,
			channelId,
			channel
		};
	}, [
		channel,
		channelId,
		spaceId
	]);
}
function useChannelWithId(inChannelId) {
	const channelId = inChannelId && isChannelStreamId(inChannelId) ? inChannelId : void 0;
	const spaceId = channelId ? spaceIdFromChannelId(channelId) : void 0;
	return useChannelWithSpaceId(channelId, spaceId);
}
function useChannelWithSpaceId(channelId, spaceId) {
	const space = useSpaceDataWithId(spaceId);
	const channelGroup = useMemo(() => space?.channelGroups.find((g) => g.channels.find((c) => c.id === channelId)), [space?.channelGroups, channelId]);
	return useMemo(() => {
		if (!channelId) return void 0;
		const channelChild = channelGroup?.channels.find((c) => c.id === channelId);
		if (!channelChild) {
			if (isDMChannelStreamId(channelId) || isGDMChannelStreamId(channelId)) return {
				id: channelId,
				label: "",
				private: true,
				topic: "",
				isAutojoin: false,
				isDefault: false,
				hideUserJoinLeaveEvents: false,
				disabled: false
			};
			return void 0;
		}
		const channel = {
			id: channelChild.id,
			label: channelChild.label,
			private: channelChild.private,
			topic: channelChild.topic,
			isAutojoin: channelChild.isAutojoin,
			isDefault: channelChild.isDefault,
			hideUserJoinLeaveEvents: channelChild.hideUserJoinLeaveEvents,
			disabled: channelChild.disabled
		};
		return channel;
	}, [channelGroup?.channels, channelId]);
}

//#endregion
//#region src/hooks/use-channel-id.ts
function useChannelId() {
	const { channelId } = useChannelContext();
	return channelId;
}

//#endregion
//#region src/hooks/use-member-ids.ts
const DEFAULT_OBSERVABLE$3 = new Observable({});
const EMPTY_MEMBER_IDS = [];
function useStreamMemberIds() {
	const { casablancaClient } = useTownsContext();
	const observable = casablancaClient?.streamsView.streamMemberIds ?? DEFAULT_OBSERVABLE$3;
	const streamMemberIds = useObservable(observable);
	return streamMemberIds;
}
function useMemberIds(streamId) {
	const { casablancaClient } = useTownsContext();
	const observable = casablancaClient?.streamsView.streamMemberIds ?? DEFAULT_OBSERVABLE$3;
	const memberIds = useObservableWith(observable, useCallback((streamMemberIds) => {
		if (!streamId) return EMPTY_MEMBER_IDS;
		return streamMemberIds[streamId] ?? EMPTY_MEMBER_IDS;
	}, [streamId]));
	return { memberIds };
}

//#endregion
//#region src/hooks/use-channel-members.ts
/**
* Returns all members of the channel in the current channel context
*/
function useChannelMembers() {
	const { channelId } = useChannelContext();
	return useMemberIds(channelId);
}

//#endregion
//#region src/hooks/use-fully-read-marker.ts
const EMPTY_UNREAD_MARKERS = new Observable({ markers: {} });
function useFullyReadMarkersWith(selector) {
	const { casablancaClient } = useTownsContext();
	const unreadMarkers = casablancaClient?.streamsView.my.unreadMarkers ?? EMPTY_UNREAD_MARKERS;
	return useObservableWith(unreadMarkers, selector);
}
function useFullyReadMarker(channelId, threadParentId) {
	const id = threadParentId ?? channelId;
	const fullyReadMarker = useFullyReadMarkersWith(useCallback((state) => id ? state.markers[id] : void 0, [id]));
	return fullyReadMarker;
}

//#endregion
//#region src/hooks/use-channel-notification-counts.ts
function useChannelNotificationCounts(channelId) {
	const fullyReadMarker = useFullyReadMarker(channelId);
	return {
		isUnread: fullyReadMarker?.isUnread === true,
		mentions: fullyReadMarker?.mentions ?? 0
	};
}

//#endregion
//#region src/store/use-timeline-store.ts
const EMPTY_TIMELINE_STORE = new TimelinesView("", void 0);
/**
* use debounced timeline store for anything that doesn't refresh after user input
* and can be deferred to the next tick
*/
function useThrottledTimelineStore(selector, throttleMs = 1e3) {
	const { casablancaClient: client } = useTownsContext();
	const timelinesView = useMemo(() => client?.streamsView.timelinesView.throttle(throttleMs) ?? EMPTY_TIMELINE_STORE, [client, throttleMs]);
	return useObservableWith(timelinesView, selector);
}
/**
* use useRawTimelineStore if you are dealing with user input and need to refresh
* the dom immediately after user clicks or enters info (for example: emoji reactions)
*/
function useRawTimelineStore(selector) {
	const { casablancaClient: client } = useTownsContext();
	const timelinesView = client?.streamsView.timelinesView ?? EMPTY_TIMELINE_STORE;
	return useObservableWith(timelinesView, selector);
}

//#endregion
//#region src/hooks/use-timeline-thread.ts
const EMPTY_TIMELINE$1 = [];
function useTimelineThread(roomId, eventId) {
	const dummyThreadStatCache = useRef({});
	return useRawTimelineStore(useCallback((state) => eventId ? {
		threadData: state.threadsStats[roomId]?.[eventId] ?? toDummyThreadStats(dummyThreadStatCache, state.timelines[roomId]?.find((e) => e.eventId === eventId)),
		messages: state.threads[roomId]?.[eventId] ?? EMPTY_TIMELINE$1
	} : {
		threadData: void 0,
		messages: EMPTY_TIMELINE$1
	}, [eventId, roomId]));
}
function toDummyThreadStats(cache, event) {
	const content = event?.content?.kind === RiverTimelineEvent.ChannelMessage ? event.content : void 0;
	if (!event || !content) return void 0;
	if (!cache.current[event.eventId]) cache.current[event.eventId] = {
		replyEventIds: new Set(),
		userIds: new Set(event.sender.id ? [event.sender.id] : []),
		latestTs: event.createdAtEpochMs,
		parentId: event.eventId,
		parentEvent: event,
		parentMessageContent: content,
		isParticipating: false
	};
	return cache.current[event.eventId];
}

//#endregion
//#region src/hooks/use-channel-thread.ts
function useChannelThread(eventId) {
	const { channelId } = useChannelContext();
	return useTimelineThread(channelId, eventId);
}

//#endregion
//#region src/hooks/use-timeline.ts
const EMPTY_TIMELINE = [];
function useTimeline(roomId) {
	const timeline = useThrottledTimelineStore(useCallback((state) => roomId ? state.timelines[roomId] : void 0, [roomId]), 10);
	return { timeline: timeline ?? EMPTY_TIMELINE };
}

//#endregion
//#region src/hooks/use-channel-timeline.ts
function useChannelTimeline() {
	const { channelId } = useChannelContext();
	return useTimeline(channelId);
}

//#endregion
//#region src/hooks/use-channel-thread-stat.ts
function useChannelThreadStat(threadParetId) {
	const { channelId } = useChannelContext();
	return useThrottledTimelineStore(useCallback((state) => state.threadsStats[channelId]?.[threadParetId], [channelId, threadParetId]), 100);
}

//#endregion
//#region src/utils/crypto-utils.ts
async function encryptAESGCM(data, chunkSize$1) {
	if (!data || data.length === 0) throw new Error("Cannot encrypt undefined or empty data");
	const cryptoKey = await generateNewAesGcmKey();
	const secretKey = await exportAesGsmKeyBytes(cryptoKey);
	const encryptedData = await encryptAesGcm(cryptoKey, data);
	const chunks = [];
	for (let i = 0; i < encryptedData.ciphertext.length; i += chunkSize$1) chunks.push({
		ciphertext: encryptedData.ciphertext.slice(i, i + chunkSize$1),
		iv: encryptedData.iv
	});
	return {
		chunks,
		secretKey
	};
}
async function encryptChunkedAESGCM(data, chunkSize$1) {
	if (!data || data.length === 0) throw new Error("Cannot encrypt undefined or empty data");
	const cryptoKey = await generateNewAesGcmKey();
	const secretKey = await exportAesGsmKeyBytes(cryptoKey);
	const maxPlaintextSize = chunkSize$1 - 16;
	const chunks = [];
	let offset = 0;
	while (offset < data.length) {
		const dataChunk = data.slice(offset, offset + maxPlaintextSize);
		const encryptedChunk = await encryptAesGcm(cryptoKey, dataChunk);
		if (encryptedChunk.ciphertext.byteLength > chunkSize$1) throw new Error(`Encrypted chunk exceeds chunkSize. Adjust chunkSize.`);
		chunks.push(encryptedChunk);
		offset += maxPlaintextSize;
	}
	return {
		chunks,
		secretKey
	};
}
async function decryptAESGCM({ ciphertext, secretKey, iv }) {
	if (secretKey.length !== 32) throw new Error("Invalid key length. AES-256-GCM requires a 32-byte key.");
	if (iv.length !== 12) throw new Error("Invalid IV length. AES-256-GCM requires a 12-byte IV.");
	const aesCryptoKey = await window.crypto.subtle.importKey("raw", secretKey, { name: "AES-GCM" }, false, ["decrypt"]);
	const decrypted = await window.crypto.subtle.decrypt({
		name: "AES-GCM",
		iv
	}, aesCryptoKey, ciphertext);
	return new Uint8Array(decrypted);
}

//#endregion
//#region src/hooks/use-chunked-media.ts
const chunkSize = 12e5;
async function getObjectData(streamId, casablancaClient, iv, secretKey) {
	if (!casablancaClient) return void 0;
	const response = casablancaClient.rpcClient.getStreamEx({ streamId: streamIdAsBytes(streamId) });
	const firstChunk = await response[Symbol.asyncIterator]().next();
	if (firstChunk.done) throw new Error(`Stream ${streamId} ended before receiving genesis miniblock.`);
	if (firstChunk.value.data.case !== "miniblock") throw new Error(`Expected genesis miniblock but received ${firstChunk.value.data.case}`);
	const mb = await unpackMiniblock(firstChunk.value.data.value, casablancaClient.opts?.unpackEnvelopeOpts);
	const payload = mb.events[0].event.payload.value;
	if (payload.content.case !== "inception") throw new Error(`Expected inception payload but received ${payload.content.case}`);
	const chunkCount = payload.content.value.chunkCount;
	const perChunkEncryption = payload.content.value.perChunkEncryption;
	const buffer = new Uint8Array(chunkCount * chunkSize);
	let offset = 0;
	let seenEndOfStream = false;
	for await (const chunk of response) {
		if (seenEndOfStream) throw new Error(`GetStreamEx: received data after end of stream for ${streamId}.`);
		if (chunk.data.case === "miniblock") {
			const mb$1 = await unpackMiniblock(chunk.data.value, casablancaClient.opts?.unpackEnvelopeOpts);
			for (const event of mb$1.events) {
				const payload$1 = event.event.payload.value;
				if (payload$1.content.case !== "chunk") continue;
				let data = payload$1.content.value.data;
				if (perChunkEncryption) data = await decryptAESGCM({
					ciphertext: payload$1.content.value.data,
					iv: payload$1.content.value.iv,
					secretKey
				});
				buffer.set(data, offset);
				offset += data.length;
			}
		} else if (chunk.data.case === "minipool") {} else if (chunk.data.case === void 0) seenEndOfStream = true;
	}
	if (perChunkEncryption) return buffer.slice(0, offset);
	return await decryptAESGCM({
		ciphertext: buffer.slice(0, offset),
		secretKey,
		iv
	});
}
async function getObjectURL(streamId, casablancaClient, iv, secretKey, useCache, mimetype) {
	const cache = await caches.open("chunked-media");
	const cacheKey = `/media-stream/${streamId}`;
	const response = await cache.match(cacheKey);
	if (response) {
		const blob$1 = await response.blob();
		return URL.createObjectURL(blob$1);
	}
	const data = await getObjectData(streamId, casablancaClient, iv, secretKey);
	if (!data) return void 0;
	const blob = new Blob([data], mimetype ? { type: mimetype } : void 0);
	const objectURL = URL.createObjectURL(blob);
	if (useCache) await cache.put(cacheKey, new Response(blob));
	return objectURL;
}
function useChunkedMedia(props) {
	const { streamId } = props;
	const { casablancaClient } = useTownsContext();
	const optimisticObjectUrl = useImageStore(({ loadedResource }) => streamId ? loadedResource[streamId]?.imageUrl : void 0);
	const [objectURL, setObjectURL] = useState(optimisticObjectUrl);
	const setLoadedResource = useImageStore(({ setLoadedResource: setLoadedResource$1 }) => setLoadedResource$1);
	useEffect(() => {
		if (!casablancaClient) return;
		const download = getObjectURL(streamId, casablancaClient, props.iv, props.secretKey, true, props.mimetype);
		download.then((objectURL$1) => {
			setObjectURL(objectURL$1);
			setLoadedResource(streamId, { imageUrl: objectURL$1 });
		}).catch((err) => {
			console.log(err);
		});
	}, [
		casablancaClient,
		props.iv,
		props.mimetype,
		props.secretKey,
		setLoadedResource,
		streamId
	]);
	return { objectURL };
}
function useDownloadFile(props) {
	const { streamId } = props;
	const { casablancaClient } = useTownsContext();
	const downloadFile = useCallback(async () => {
		if (!casablancaClient) return;
		return getObjectURL(streamId, casablancaClient, props.iv, props.secretKey, false, props.mimetype);
	}, [
		casablancaClient,
		streamId,
		props.iv,
		props.secretKey,
		props.mimetype
	]);
	return { downloadFile };
}

//#endregion
//#region src/hooks/use-set-channel-permission-overrides.ts
function useSetChannelPermissionOverrides() {
	const { baseTransactor } = useBaseWrites();
	const result = useTransaction({
		debugName: "useSetChannelPermissionOverrides",
		execute: async ({ spaceNetworkId, channelId, roleId, permissions, signer }) => {
			const args = {
				spaceNetworkId,
				roleId,
				channelId,
				permissions
			};
			return baseTransactor.createTransaction({
				debugName: "setChannelPermissionOverridesTransaction",
				type: BlockchainTransactionType.SetChannelPermissionOverrides,
				signer,
				contextData: {
					spaceStreamId: spaceNetworkId,
					roleId
				},
				aaExecute: async () => {
					if (!baseTransactor.userOps) throw new Error("userOps not found");
					return baseTransactor.userOps?.sendSetChannelPermissionOverridesOp([args, signer]);
				},
				eoaExecute: async () => {
					return baseTransactor.spaceDapp.setChannelPermissionOverrides(args, signer);
				},
				errorDecoder: (error) => baseTransactor.getDecodedErrorForSpace(spaceNetworkId, error)
			});
		},
		invalidateQueries: (params) => [blockchainKeys.channelPermissionOverrides(params.spaceNetworkId, params.roleId, params.channelId)]
	});
	const setChannelPermissionOverridesTransactionMethod = useCallback(async function(spaceNetworkId, channelId, roleId, permissions, signer) {
		return result.execute({
			spaceNetworkId,
			channelId,
			roleId,
			permissions,
			signer
		});
	}, [result]);
	return {
		...result,
		setChannelPermissionOverridesTransaction: setChannelPermissionOverridesTransactionMethod
	};
}
function useClearChannelPermissionOverrides() {
	const { baseTransactor } = useBaseWrites();
	const result = useTransaction({
		debugName: "useClearChannelPermissionOverrides",
		execute: async ({ spaceNetworkId, channelId, roleId, signer }) => {
			const args = {
				spaceNetworkId,
				roleId,
				channelId
			};
			return baseTransactor.createTransaction({
				debugName: "clearChannelPermissionOverridesTransaction",
				type: BlockchainTransactionType.ClearChannelPermissionOverrides,
				signer,
				contextData: {
					spaceStreamId: spaceNetworkId,
					channelId,
					roleId
				},
				aaExecute: async () => {
					if (!baseTransactor.userOps) throw new Error("userOps not found");
					return baseTransactor.userOps?.sendClearChannelPermissionOverridesOp([args, signer]);
				},
				eoaExecute: async () => {
					return baseTransactor.spaceDapp.clearChannelPermissionOverrides(args, signer);
				},
				errorDecoder: (error) => baseTransactor.getDecodedErrorForSpace(spaceNetworkId, error)
			});
		},
		invalidateQueries: (params) => [blockchainKeys.channelPermissionOverrides(params.spaceNetworkId, params.roleId, params.channelId)]
	});
	const clearChannelPermissionOverridesTransactionMethod = useCallback(async function(spaceNetworkId, channelId, roleId, signer) {
		return result.execute({
			spaceNetworkId,
			channelId,
			roleId,
			signer
		});
	}, [result]);
	return {
		...result,
		clearChannelPermissionOverridesTransaction: clearChannelPermissionOverridesTransactionMethod
	};
}

//#endregion
//#region src/hooks/use-create-channel-transaction.ts
/**
* Combine river channel creation and Smart Contract channel
* creation into one hook.
*/
function useCreateChannelTransaction() {
	const { clientSingleton, createTownsChannel } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useCreateChannelTransaction",
		execute: async ({ createInfo, signer }) => {
			if (!clientSingleton) throw new Error("Client singleton not initialized");
			return baseTransactor.createChannelTransaction(createInfo, signer);
		},
		waitForTransaction: async (context, params) => {
			if (!clientSingleton) throw new Error("Client singleton not initialized");
			const txContext = await baseTransactor.waitForBlockchainTransaction(context);
			if (!txContext) throw new Error("Transaction context not found");
			return createTownsChannel(params.createInfo, txContext);
		}
	});
	return {
		...tx,
		createChannelTransaction: tx.execute
	};
}

//#endregion
//#region src/hooks/use-create-role-transaction.ts
/**
* Hook to create a role with a transaction.
*/
function useCreateRoleTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useCreateRoleTransaction",
		execute: async ({ spaceNetworkId, roleName, permissions, users, ruleData, signer }) => {
			return baseTransactor.createRoleTransaction(spaceNetworkId, roleName, permissions, users, ruleData, signer);
		},
		invalidateQueries: (params) => [blockchainKeys.roles(params.spaceNetworkId)]
	});
	return {
		...tx,
		createRoleTransaction: tx.execute
	};
}

//#endregion
//#region src/hooks/use-my-user-id.ts
const useMyUserId = () => {
	const { signerContext } = useTownsContext();
	return useMemo(() => {
		return signerContext ? userIdFromAddress(signerContext.creatorAddress) : void 0;
	}, [signerContext]);
};

//#endregion
//#region src/hooks/use-member-of.ts
const useMemberOf = (userId) => {
	return useUserLookupStore((s) => userId ? s.allUsers[userId] : void 0);
};

//#endregion
//#region src/hooks/use-my-default-usernames.ts
const useMyDefaultUsernames = () => {
	const userId = useMyUserId();
	const memberOf = useMemberOf(userId);
	return useMemo(() => Object.values(memberOf ?? {}).map((space) => space.username.trim()).filter((username) => username !== ""), [memberOf]);
};

//#endregion
//#region src/hooks/use-create-space-transaction.ts
/**
* Combine space creation and smart contract space
* creation into one hook.
*/
function useCreateSpaceTransaction({ onCreateSpaceFlowStatus }) {
	const { createTownsSpace } = useTownsClient();
	const defaultUsernames = useMyDefaultUsernames();
	const { clientSingleton } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useCreateSpaceTransaction",
		execute: async ({ createInfo, membershipInfo, signer, onCreateSpaceFlowStatus: onCreateSpaceFlowStatus$1 }) => {
			if (!clientSingleton) throw new Error("Client singleton not initialized");
			return baseTransactor.createSpaceTransaction(createInfo, membershipInfo, signer, onCreateSpaceFlowStatus$1);
		},
		waitForTransaction: async (context) => {
			if (!clientSingleton) throw new Error("Client singleton not initialized");
			const txResult = await baseTransactor.waitForBlockchainTransaction(context);
			if (txResult?.status === TransactionStatus.Success) await createTownsSpace(txResult, defaultUsernames, onCreateSpaceFlowStatus);
			return txResult;
		}
	});
	return {
		...tx,
		createSpaceTransactionWithRole: tx.execute
	};
}

//#endregion
//#region src/hooks/use-debug-deps.ts
/**
* Example:
const MyComponent = ({ userId, filter }) => {
const [data, setData] = useState(null)

useDebugDeps('MyComponent useEffect', { userId, filter, data })

useEffect(() => {
// Your effect logic here
}, [userId, filter, data])

return <div>...</div>

*/
function useDebugDeps(label, deps) {
	const previousDeps = useRef({});
	useEffect(() => {
		const changedDeps = [];
		const currentKeys = Object.keys(deps);
		const previousKeys = Object.keys(previousDeps.current);
		if (previousKeys.length > 0 && previousKeys.length !== currentKeys.length) console.log(`[${label}] Dependencies object size changed:`, {
			previous: previousKeys.length,
			current: currentKeys.length,
			previousKeys,
			currentKeys
		});
		currentKeys.forEach((key) => {
			if (!Object.is(deps[key], previousDeps.current[key])) changedDeps.push({
				key,
				previous: previousDeps.current[key],
				current: deps[key]
			});
		});
		previousKeys.forEach((key) => {
			if (!(key in deps)) changedDeps.push({
				key,
				previous: previousDeps.current[key],
				current: void 0
			});
		});
		if (previousKeys.length > 0 && changedDeps.length > 0) {
			console.log(`[${label}] Dependencies changed:`, changedDeps);
			console.table(changedDeps);
		}
		previousDeps.current = { ...deps };
	}, [deps, label]);
}

//#endregion
//#region src/hooks/use-delete-role-transaction.ts
function useDeleteRoleTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useDeleteRoleTransaction",
		execute: async ({ spaceNetworkId, roleId, signer }) => {
			return baseTransactor.deleteRoleTransaction(spaceNetworkId, roleId, signer);
		},
		invalidateQueries: (params) => [blockchainKeys.roles(params.spaceNetworkId)]
	});
	return {
		...tx,
		deleteRoleTransaction: tx.execute
	};
}

//#endregion
//#region src/utils/markdownToPlainText.ts
const markdownToPlainText = (text) => {
	if (!text || typeof text !== "string") return "";
	return new Marked({ gfm: true }).use(markedPlaintify()).parse(text, { async: false });
};

//#endregion
//#region src/utils/isMediaMimeType.ts
/**
* Common image mimetypes.
* Based on https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types#image_types
* excluding image/svg+xml
*/
const allowedMimeTypes = [
	"image/jpeg",
	"image/png",
	"image/avif",
	"image/webp",
	"image/gif",
	"image/apng"
];
function isMediaMimeType(mimetype) {
	return allowedMimeTypes.includes(mimetype);
}

//#endregion
//#region src/hooks/use-dm-latest-message.ts
const EMPTY_LATEST_MESSAGE = {
	latest: void 0,
	unreadCount: 0
};
function useDMLatestMessage(roomId, ignoreThreads = true) {
	const unreadMarker = useFullyReadMarkersWith(useCallback((state) => state.markers[roomId], [roomId]));
	const stableRef = useRef(void 0);
	const latestMessage = useThrottledTimelineStore(useCallback((state) => {
		const timeline = roomId ? state.timelines[roomId] : void 0;
		if (!timeline) return EMPTY_LATEST_MESSAGE;
		const hasRelevantUnreadMarker = unreadMarker?.isUnread && timeline.some((event) => event.eventId === unreadMarker?.eventId);
		let markerReached = false;
		let unreadCount = 0;
		let latest$1;
		for (let i = timeline.length - 1; i >= 0; i--) {
			const message = timeline[i];
			const info = toMessageInfo(message);
			if (!markerReached && info && hasRelevantUnreadMarker) unreadCount++;
			if (!latest$1 && info && (!ignoreThreads || !message.threadParentId)) latest$1 = {
				createdAtEpochMs: message.createdAtEpochMs,
				info,
				sender: message.sender
			};
			if (unreadMarker?.eventId === message.eventId) markerReached = true;
		}
		const result = {
			latest: latest$1,
			unreadCount
		};
		if (!stableRef.current || !isEqual(stableRef.current.latest, result.latest)) stableRef.current = result;
		return stableRef.current;
	}, [
		ignoreThreads,
		roomId,
		unreadMarker?.eventId,
		unreadMarker?.isUnread
	]), 250);
	const [latest, setLatest] = useState(latestMessage);
	useEffect(() => {
		const TIMEOUT = 1e3 * 10;
		const update = () => {
			setLatest((prev) => latestMessage.latest?.info?.kind !== "encrypted" || latestMessage.latest.createdAtEpochMs < Date.now() - TIMEOUT ? latestMessage : prev);
		};
		const info = latestMessage.latest?.info;
		if (info && info.kind !== "encrypted") update();
		else {
			const timeout = setTimeout(update, TIMEOUT);
			return () => {
				clearTimeout(timeout);
			};
		}
	}, [latestMessage]);
	return latest;
}
function toMessageInfo(message) {
	const { content, sender } = message;
	if (content?.kind === RiverTimelineEvent.ChannelMessageEncrypted) return {
		kind: "encrypted",
		content
	};
	if (content?.kind === RiverTimelineEvent.Inception) {
		if (content.type === "dmChannelPayload") return {
			kind: "dm_created",
			creatorId: content.creatorId
		};
		if (content.type === "gdmChannelPayload") return {
			kind: "gdm_created",
			creatorId: content.creatorId
		};
	}
	if (content?.kind === RiverTimelineEvent.StreamMembership) {
		if (content.membership === Membership.Join) return {
			kind: "member_added",
			userId: content.userId,
			senderId: sender.id !== content.userId ? sender.id : void 0
		};
		if (content.membership === Membership.Leave) return {
			kind: "member_left",
			userId: content.userId,
			senderId: sender.id !== content.userId ? sender.id : void 0
		};
		if (content.membership === Membership.Invite) return {
			kind: "member_invited",
			userId: content.userId
		};
	}
	if (content?.kind !== RiverTimelineEvent.ChannelMessage) return void 0;
	if (!content.content) return void 0;
	switch (content.content.msgType) {
		case MessageType.Text: {
			const hasUnfurledLink = content.attachments?.some((x) => x.type === "unfurled_link");
			const isEmbeddedMessage = content.attachments?.some((attachment) => attachment.type === "embedded_message");
			if (!isEmbeddedMessage && !hasUnfurledLink && content.attachments && content.attachments.length > 0) {
				const hasGifAttachment = content.attachments.some((attachment) => {
					return attachment.type === "chunked_media" && attachment.info.mimetype === "image/gif" || attachment.type === "image" && "mimetype" in attachment.info && attachment.info.mimetype === "image/gif";
				});
				if (hasGifAttachment) return { kind: "gif" };
				const images = content.attachments.filter((attachment) => {
					const isGif = attachment.type === "chunked_media" && attachment.info.mimetype === "image/gif" || attachment.type === "image" && "mimetype" in attachment.info && attachment.info.mimetype === "image/gif";
					const hasMedia = attachment.type === "chunked_media" && isMediaMimeType(attachment.info.mimetype);
					return !isGif && hasMedia || attachment.type === "image" && !("mimetype" in attachment.info && attachment.info.mimetype === "image/gif");
				});
				const hasImages = images.length > 0;
				if (hasImages) return {
					kind: "image",
					images
				};
				return {
					kind: "attachment",
					attachments: content.attachments
				};
			}
			return {
				kind: "text",
				text: markdownToPlainText(content.body)
			};
		}
		case MessageType.Image: {
			const isGif = content.content.info?.mimetype === "image/gif";
			if (isGif) return { kind: "gif" };
			return {
				kind: "image",
				images: []
			};
		}
		default: return void 0;
	}
}

//#endregion
//#region src/hooks/use-user.ts
function useUser(userId) {
	const lookupUser = useUserLookupStore((s) => s.lookupUser);
	return userId ? lookupUser(userId) ?? getStableDefault(userId) : void 0;
}
const getStableDefault = memoize((userId) => {
	return {
		userId,
		username: "",
		usernameConfirmed: true,
		usernameEncrypted: false,
		displayName: "",
		displayNameEncrypted: false
	};
}, (userId) => userId);

//#endregion
//#region src/hooks/use-my-profile.ts
function useMyProfile() {
	const userId = useMyUserId();
	return useUser(userId);
}

//#endregion
//#region src/hooks/use-dms-and-gdms.ts
const DEFAULT_OBSERVABLE$2 = new Observable([]);
function useDmsAndGdms() {
	const casablancaClient = useTownsContext().casablancaClient;
	const observable = casablancaClient?.streamsView.my.dmsAndGdms ?? DEFAULT_OBSERVABLE$2;
	const dmsAndGdms = useObservable(observable);
	return { dmsAndGdms };
}

//#endregion
//#region src/hooks/use-dm-data.ts
function useDMData(roomId) {
	const userId = useMyProfile()?.userId;
	const { dmsAndGdms } = useDmsAndGdms();
	const data = useMemo(() => {
		return dmsAndGdms.find((dm) => dm.id === roomId);
	}, [dmsAndGdms, roomId]);
	const counterParty = useMemo(() => {
		return data?.userIds.find((u) => u !== userId);
	}, [data, userId]);
	return {
		data,
		counterParty
	};
}

//#endregion
//#region src/hooks/use-dms-and-gdms-unreads.ts
const DEFAULT_UNREADS = new Observable(new Set());
function useDmsAndGdmsUnreads() {
	const casablancaClient = useTownsContext().casablancaClient;
	const observable = casablancaClient?.streamsView.my.dmsAndGdmsUnreadIds ?? DEFAULT_UNREADS;
	const dmsAndGdmsUnreadIds = useObservable(observable);
	return { dmsAndGdmsUnreadIds };
}

//#endregion
//#region src/utils/Badger.ts
var Badger = class Badger {
	static _faviconSingleton;
	static faviconSingleton() {
		if (!Badger._faviconSingleton) Badger._faviconSingleton = new Badger();
		return Badger._faviconSingleton;
	}
	backgroundColor;
	liteBackgroundColor;
	liveBackgroundColor;
	color;
	scale;
	liteScale;
	src;
	canvas;
	faviconEL;
	ctx;
	faviconSize = 0;
	_value = 0;
	_showDot = false;
	_hasLive = false;
	img;
	constructor(backgroundColor = "#1FDBF1", liteBackgroundColor = "#1FDBF1", liveBackgroundColor = "#FF3B30", color = "#fff", scale = .6, liteScale = .4, src = null) {
		this.backgroundColor = backgroundColor;
		this.liteBackgroundColor = liteBackgroundColor;
		this.liveBackgroundColor = liveBackgroundColor;
		this.color = color;
		this.scale = scale;
		this.liteScale = liteScale;
		if (document) {
			this.canvas = document.createElement("canvas");
			this.faviconEL = document.querySelector("link[rel$=icon]");
			if (!this.faviconEL) {
				const url = this.canvas.toDataURL("image/png");
				const elm = document.createElement("link");
				elm.setAttribute("rel", "icon");
				elm.setAttribute("type", "image/png");
				elm.setAttribute("href", url);
				const head = document.querySelector("head");
				if (head) {
					head.appendChild(elm);
					this.faviconEL = elm;
				}
			}
			this.src = src ?? this.faviconEL?.getAttribute("href") ?? null;
			this.ctx = this.canvas.getContext("2d");
		} else {
			this.canvas = null;
			this.src = null;
			this.faviconEL = null;
			this.ctx = null;
		}
	}
	_drawIcon() {
		if (!this.img || !this.ctx) return;
		this.ctx.clearRect(0, 0, this.faviconSize, this.faviconSize);
		this.ctx.drawImage(this.img, 0, 0, this.faviconSize, this.faviconSize);
	}
	_drawShape() {
		if (!this.ctx) return;
		const opt = {
			w: this.faviconSize * this.scale,
			h: this.faviconSize * this.scale,
			x: this.faviconSize * (1 - this.scale),
			y: this.faviconSize * (1 - this.scale)
		};
		const numDigits = this.value.toString().length;
		if (numDigits === 2) {
			opt.x = opt.x - opt.w * .4;
			opt.w = opt.w * 1.4;
		} else if (numDigits >= 3) {
			opt.x = opt.x - opt.w * .65;
			opt.w = opt.w * 1.65;
		}
		this.ctx.beginPath();
		if (numDigits === 1) this.ctx.arc(opt.x + opt.w / 2, opt.y + opt.h / 2, opt.h / 2, 0, 2 * Math.PI);
		else {
			this.ctx.moveTo(opt.x + opt.w / 2, opt.y);
			this.ctx.lineTo(opt.x + opt.w - opt.h / 2, opt.y);
			this.ctx.quadraticCurveTo(opt.x + opt.w, opt.y, opt.x + opt.w, opt.y + opt.h / 2);
			this.ctx.lineTo(opt.x + opt.w, opt.y + opt.h - opt.h / 2);
			this.ctx.quadraticCurveTo(opt.x + opt.w, opt.y + opt.h, opt.x + opt.w - opt.h / 2, opt.y + opt.h);
			this.ctx.lineTo(opt.x + opt.h / 2, opt.y + opt.h);
			this.ctx.quadraticCurveTo(opt.x, opt.y + opt.h, opt.x, opt.y + opt.h - opt.h / 2);
			this.ctx.lineTo(opt.x, opt.y + opt.h / 2);
			this.ctx.quadraticCurveTo(opt.x, opt.y, opt.x + opt.h / 2, opt.y);
		}
		this.ctx.fillStyle = this.backgroundColor;
		this.ctx.fill();
		this.ctx.closePath();
		this.ctx.beginPath();
		this.ctx.stroke();
		this.ctx.textAlign = "center";
		this.ctx.font = `bold ${Math.floor(opt.h * (this.value > 99 ? .85 : 1))}px sans-serif`;
		this.ctx.fillStyle = this.color;
		if (this.value > 99) this.ctx.fillText(this.value > 9999 ? "9k+" : this.value > 999 ? Math.floor(this.value / 1e3).toString() + "k+" : "99+", Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * .2));
		else this.ctx.fillText(this.value.toString(), Math.floor(opt.x + opt.w / 2), Math.floor(opt.y + opt.h - opt.h * .15));
		this.ctx.closePath();
	}
	_drawLiteShape() {
		this._drawDotShape(this.liteBackgroundColor);
	}
	_drawLiveShape() {
		this._drawDotShape(this.liveBackgroundColor);
	}
	_drawDotShape(fillColor) {
		if (!this.ctx) return;
		const opt = {
			w: this.faviconSize * this.liteScale,
			h: this.faviconSize * this.liteScale,
			x: this.faviconSize * (1 - this.liteScale),
			y: this.faviconSize * (1 - this.liteScale)
		};
		const fillCorner = true;
		const TopLeft = {
			x: opt.x,
			y: opt.y
		};
		const TopRight = {
			x: opt.x + opt.w,
			y: opt.y
		};
		const BottomLeft = {
			x: opt.x,
			y: opt.y + opt.h
		};
		const BottomRight = {
			x: opt.x + opt.w,
			y: opt.y + opt.h
		};
		const Top = {
			x: opt.x + opt.w / 2,
			y: opt.y
		};
		const Bottom = {
			x: opt.x + opt.w / 2,
			y: opt.y + opt.h
		};
		const Left = {
			x: opt.x,
			y: opt.y + opt.h / 2
		};
		const Right = {
			x: opt.x + opt.w,
			y: opt.y + opt.h / 2
		};
		this.ctx.beginPath();
		this.ctx.moveTo(Top.x, Top.y);
		this.ctx.quadraticCurveTo(TopRight.x, TopRight.y, Right.x, Right.y);
		if (fillCorner) {
			this.ctx.lineTo(BottomRight.x, BottomRight.y);
			this.ctx.lineTo(Bottom.x, Bottom.y);
		} else this.ctx.quadraticCurveTo(BottomRight.x, BottomRight.y, Bottom.x, Bottom.y);
		this.ctx.quadraticCurveTo(BottomLeft.x, BottomLeft.y, Left.x, Left.y);
		this.ctx.quadraticCurveTo(TopLeft.x, TopLeft.y, Top.x, Top.y);
		this.ctx.fillStyle = fillColor;
		this.ctx.fill();
		this.ctx.closePath();
	}
	_drawFavicon() {
		if (!this.faviconEL || !this.canvas) return;
		const url = this.canvas.toDataURL("image/png");
		if (url) this.faviconEL.setAttribute("href", url);
	}
	_draw() {
		this._drawIcon();
		if (this.value) this._drawShape();
		else if (this._hasLive) this._drawLiveShape();
		else if (this._showDot) this._drawLiteShape();
		this._drawFavicon();
	}
	_setup() {
		if (!this.canvas) return;
		this.faviconSize = this.img?.naturalWidth ?? 0;
		this.canvas.width = this.faviconSize;
		this.canvas.height = this.faviconSize;
	}
	_update() {
		if (this.img) this._draw();
		else if (this.src) {
			this.img = new Image();
			this.img.setAttribute("crossOrigin", "anonymous");
			this.img.addEventListener("load", () => {
				this._setup();
				this._draw();
			});
			this.img.src = this.src;
		}
	}
	get value() {
		return this._value;
	}
	badge(mentionCount, hasLive, hasUnread) {
		if (mentionCount === this._value && hasLive === this._hasLive && hasUnread === this._showDot) return;
		this._value = mentionCount;
		this._hasLive = hasLive;
		this._showDot = hasUnread;
		this._update();
	}
};

//#endregion
//#region src/hooks/use-space-unreads.ts
const EMPTY_SPACE_UNREADS = new Observable({
	spaceUnreads: {},
	spaceMentions: {},
	spaceUnreadChannelIds: {}
});
function useSpaceUnreads() {
	const { casablancaClient: client } = useTownsContext();
	const observable = client?.streamsView.my.spaceUnreads ?? EMPTY_SPACE_UNREADS;
	const data = useObservable(observable);
	return data;
}

//#endregion
//#region src/hooks/TownsContext/useFavIconBadge.ts
const getBadgeCount = (invitedToIds, spaceUnreads, spaceMentions, dmsAndGdmsUnreadIds) => {
	const hasUnread = invitedToIds.length > 0 || Object.values(spaceUnreads).indexOf(true) >= 0 || dmsAndGdmsUnreadIds.size > 0;
	const mentions = Object.values(spaceMentions).reduce((a, b) => (a ?? 0) + (b ?? 0), 0);
	return {
		mentions,
		hasUnread
	};
};
function useBadgeStatus() {
	const { dmsAndGdmsUnreadIds } = useDmsAndGdmsUnreads();
	const { spaceUnreads, spaceMentions } = useSpaceUnreads();
	return useMemo(() => getBadgeCount([], spaceUnreads, spaceMentions, dmsAndGdmsUnreadIds), [
		spaceMentions,
		spaceUnreads,
		dmsAndGdmsUnreadIds
	]);
}
function useAppBadge() {
	const { hasUnread, mentions } = useBadgeStatus();
	useEffect(() => {
		(async () => {
			if (typeof navigator?.setAppBadge === "function" && typeof navigator?.clearAppBadge === "function") if (mentions ?? false) await navigator.setAppBadge?.(mentions);
			else if (hasUnread) await navigator.setAppBadge?.();
			else await navigator.clearAppBadge?.();
		})();
	}, [hasUnread, mentions]);
}
function useFavIconBadge({ hasLive }) {
	const { hasUnread, mentions } = useBadgeStatus();
	useEffect(() => {
		Badger.faviconSingleton().badge(mentions ?? 0, hasLive, hasUnread);
		console.log("calculated new badge value", {
			mentions,
			hasLive,
			hasUnread
		});
	}, [
		hasUnread,
		hasLive,
		mentions
	]);
}

//#endregion
//#region src/hooks/use-message-reactions.ts
const EMPTY_REACTIONS = {};
function useMessageReactions(streamId, eventId) {
	const reactions = useRawTimelineStore(useCallback((state) => {
		return streamId && eventId ? state.reactions[streamId]?.[eventId] : void 0;
	}, [streamId, eventId]));
	return reactions ?? EMPTY_REACTIONS;
}

//#endregion
//#region src/hooks/use-message-thread-stats.ts
function useMessageThreadStats(streamId, eventId) {
	const threadStats = useThrottledTimelineStore(useCallback((state) => streamId && eventId ? state.threadsStats[streamId]?.[eventId] : void 0, [eventId, streamId]));
	return threadStats;
}

//#endregion
//#region src/hooks/use-message-tips.ts
function useMessageTips(streamId, eventId) {
	const tips = useThrottledTimelineStore(useCallback((state) => streamId && eventId ? state.tips[streamId]?.[eventId] : void 0, [streamId, eventId]));
	return tips;
}

//#endregion
//#region src/hooks/CasablancClient/useCasablancaStreamMember.ts
function useCasablancaStreamMember(roomId, userId) {
	const channelStream = useCasablancaStream(roomId);
	const [streamMember, setStreamMember] = useState({
		membership: Membership.None,
		data: void 0
	});
	useEffect(() => {
		if (!userId || !roomId || !channelStream) return;
		const updateMember = () => {
			setStreamMember({
				membership: getCasablancaMembership(channelStream, userId),
				data: channelStream.view.getMembers().joined.get(userId)
			});
		};
		updateMember();
		const onStreamUserEvent = (streamId, newUserId) => {
			if (userId === newUserId) updateMember();
		};
		const onStreamInitialized = (streamId) => {
			if (streamId === roomId) updateMember();
		};
		channelStream.on("streamNewUserJoined", onStreamUserEvent);
		channelStream.on("streamNewUserInvited", onStreamUserEvent);
		channelStream.on("streamUserLeft", onStreamUserEvent);
		channelStream.on("streamInitialized", onStreamInitialized);
		return () => {
			channelStream.off("streamNewUserJoined", onStreamUserEvent);
			channelStream.off("streamNewUserInvited", onStreamUserEvent);
			channelStream.off("streamUserLeft", onStreamUserEvent);
			channelStream.off("streamInitialized", onStreamInitialized);
		};
	}, [
		roomId,
		channelStream,
		userId
	]);
	return streamMember;
}
function getCasablancaMembership(stream, userId) {
	if (stream.view.getMembers().joinedUsers.has(userId)) return Membership.Join;
	else if (stream.view.getMembers().invitedUsers.has(userId)) return Membership.Invite;
	else return Membership.None;
}

//#endregion
//#region src/hooks/use-membership.ts
function useMembership(roomId, userId) {
	const member = useCasablancaStreamMember(roomId, userId);
	return member.membership ?? Membership.None;
}

//#endregion
//#region src/hooks/use-my-channels.ts
function useMyChannels(space) {
	const casablancaChannelIds = useMyMembershipsCasablanca();
	const filterUnjoinedChannels = useCallback((channels) => {
		return channels.filter((channel) => {
			return casablancaChannelIds.has(channel.id);
		});
	}, [casablancaChannelIds]);
	const channelGroups = useMemo(() => {
		return space?.channelGroups.map((group) => {
			return {
				...group,
				channels: filterUnjoinedChannels(group.channels)
			};
		}) ?? [];
	}, [filterUnjoinedChannels, space?.channelGroups]);
	return channelGroups;
}
function useMyMembershipsCasablanca() {
	const { casablancaClient } = useTownsContext();
	const [myMemberships, setMyMemberships] = useState(new Set());
	const userStream = useCasablancaStream(casablancaClient?.userStreamId);
	useEffect(() => {
		if (!casablancaClient || !userStream) return;
		const updateState = () => {
			if (!userStream) return;
			const memberships = new Set(Object.values(userStream.view.userContent.streamMemberships).filter((membership) => membership?.op === MembershipOp.SO_JOIN).map((membership) => streamIdAsString(membership.streamId)));
			setMyMemberships((prev) => {
				if (isEqual(prev, memberships)) return prev;
				return memberships;
			});
		};
		const onUserStreamMembershipChanged = (_streamId) => {
			updateState();
		};
		const onStreamInitialized = (streamId) => {
			if (isUserStreamId(streamId)) updateState();
		};
		updateState();
		casablancaClient.on("userStreamMembershipChanged", onUserStreamMembershipChanged);
		casablancaClient.on("streamInitialized", onStreamInitialized);
		return () => {
			casablancaClient.off("userStreamMembershipChanged", onUserStreamMembershipChanged);
			casablancaClient.off("streamInitialized", onStreamInitialized);
		};
	}, [casablancaClient, userStream]);
	return myMemberships;
}

//#endregion
//#region src/hooks/use-mutation-space-info-cache.ts
function useMutationSpaceInfoCache(props) {
	const queryClient$1 = useQueryClient();
	return useMutation({
		mutationFn: (spaceInfo) => {
			if (!spaceInfo) return Promise.resolve(void 0);
			useOfflineStore.getState().setOfflineSpaceInfo(spaceInfo);
			return Promise.resolve(spaceInfo);
		},
		onSuccess: (data) => {
			if (!data) return;
			const queryKey = blockchainKeys.spaceInfo(data.networkId ?? "");
			props?.onSuccess?.(data);
			return queryClient$1.invalidateQueries({ queryKey });
		},
		onError: (error) => {
			console.error("[useMutationSpaceInfoCache] error", error);
		}
	});
}

//#endregion
//#region src/hooks/use-my-memberships.ts
const DEFAULT_MEMBERSHIPS = new Observable({});
function useMyMemberships() {
	const { casablancaClient } = useTownsContext();
	const myMemberships = casablancaClient?.streamsView.my.memberships ?? DEFAULT_MEMBERSHIPS;
	return useObservable(myMemberships);
}

//#endregion
//#region src/hooks/use-my-membership.ts
/**
* useMyMembership is different than useMembership in that it uses the userStream to determine the membership
* we drive our UI off of the userStream, and join and leave channels by submitting userStream events
* so this is the correct way to determine membership
* @param streamId
* @returns Membership
*/
function useMyMembership(streamId) {
	const memberships = useMyMemberships();
	return streamId ? memberships[streamId] ?? Membership.None : Membership.None;
}

//#endregion
//#region src/hooks/use-pins.ts
function usePins(streamId) {
	const { casablancaClient: client } = useTownsContext();
	const [pins, setPins] = useState(() => {
		if (!streamId || !client) return void 0;
		return client.stream(streamId)?.view.getMembers()?.pins.map((x) => toTimelinePin(x, client.userId)) ?? [];
	});
	useEffect(() => {
		if (!client || !streamId) return;
		const updateState = () => {
			const pins$1 = client.stream(streamId)?.view.getMembers()?.pins.map((x) => toTimelinePin(x, client.userId)) ?? [];
			setPins((prev) => {
				if (isEqual(prev, pins$1)) return prev;
				return pins$1;
			});
		};
		const onPinUpdated = (inStreamId) => {
			if (inStreamId === streamId) updateState();
		};
		updateState();
		client.on("channelPinDecrypted", onPinUpdated);
		client.on("channelPinAdded", onPinUpdated);
		client.on("channelPinRemoved", onPinUpdated);
		return () => {
			client.off("channelPinDecrypted", onPinUpdated);
			client.off("channelPinAdded", onPinUpdated);
			client.off("channelPinRemoved", onPinUpdated);
		};
	}, [client, streamId]);
	return pins;
}
function toTimelinePin(pin, userId) {
	return {
		...pin,
		timelineEvent: toEvent(pin.event, userId)
	};
}

//#endregion
//#region src/hooks/use-transfer-ownership.ts
function useTransferOwnership({ onSuccess, onError } = {}) {
	const { baseTransactor } = useBaseWrites();
	const execute = useCallback((args) => baseTransactor.createTransaction({
		signer: args.signer,
		type: BlockchainTransactionType.TransferOwnership,
		debugName: "transferOwnershipTransaction",
		aaExecute: () => baseTransactor.userOps?.transferOwnership({
			signer: args.signer,
			from: args.from,
			to: args.to,
			tokenId: args.tokenId
		}),
		eoaExecute: () => baseTransactor.spaceDapp.spaceOwner.transferOwnership({
			signer: args.signer,
			from: args.from,
			to: args.to,
			tokenId: args.tokenId
		}),
		errorDecoder: (error) => baseTransactor.spaceDapp.parseSpaceOwnerError(error)
	}), [baseTransactor]);
	return useTransaction({
		debugName: "useTransferAssetTransaction",
		execute: async ({ from, to, tokenId, signer }) => {
			return execute({
				from,
				to,
				tokenId,
				signer
			});
		},
		onSuccess,
		onError
	});
}
function useDisableGuardian({ onSuccess, onError } = {}) {
	const { baseTransactor } = useBaseWrites();
	return useTransaction({
		debugName: "useTransferOwnershipTransaction",
		execute: async ({ signer }) => {
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.TransferOwnership,
				debugName: "disableGuardianTransaction",
				aaExecute: () => baseTransactor.userOps?.disableGuardian({ signer }),
				eoaExecute: () => baseTransactor.spaceDapp.spaceOwner.disableGuardian({ signer }),
				errorDecoder: (error) => baseTransactor.spaceDapp.parseSpaceOwnerError(error)
			});
		},
		onSuccess,
		onError
	});
}
function useEnableGuardian({ onSuccess, onError } = {}) {
	const { baseTransactor } = useBaseWrites();
	return useTransaction({
		debugName: "useEnableGuardian",
		execute: async ({ signer }) => {
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.TransferOwnership,
				debugName: "enableGuardianTransaction",
				aaExecute: () => baseTransactor.userOps?.enableGuardian({ signer }),
				eoaExecute: () => baseTransactor.spaceDapp.spaceOwner.enableGuardian({ signer }),
				errorDecoder: (error) => baseTransactor.spaceDapp.parseSpaceOwnerError(error)
			});
		},
		onSuccess,
		onError
	});
}

//#endregion
//#region src/hooks/use-space-lastaccessed.ts
const EMPTY_SPACE_LAST_ACCESSED = new Observable({});
function useSpaceLastAccessed() {
	const { casablancaClient: client } = useTownsContext();
	const observable = client?.streamsView.lastAccessedAt ?? EMPTY_SPACE_LAST_ACCESSED;
	const data = useObservable(observable);
	return data;
}

//#endregion
//#region src/hooks/use-space-members.ts
/**
* Returns all members from the space in the current space context
*/
function useSpaceMembers() {
	const { spaceId } = useSpaceContext();
	return useMemberIds(spaceId);
}
function useSpaceMembersWithFallback(spaceId, { excludeBots = false } = {}) {
	const { casablancaClient } = useTownsContext();
	const streamMemberIds = useStreamMemberIds();
	const { spaceIds: allSpaceIds } = useSpacesIds();
	const spaceIds = useMemo(() => spaceId ? [spaceId] : allSpaceIds, [spaceId, allSpaceIds]);
	const memberIds = useMemo(() => {
		const userFilter = (userId, spaceId$1) => {
			if (!isDefined(userId)) return false;
			if (excludeBots) {
				const memberInfo = casablancaClient?.stream(spaceId$1)?.view.membershipContent.joined.get(userId);
				const isBot = memberInfo?.appAddress !== void 0 && memberInfo.appAddress !== zeroAddress;
				if (isBot) return false;
			}
			return true;
		};
		return Array.from(new Set(spaceIds.flatMap((spaceId$1) => (streamMemberIds[spaceId$1] ?? []).filter((userId) => userFilter(userId, spaceId$1)))));
	}, [
		spaceIds,
		excludeBots,
		casablancaClient,
		streamMemberIds
	]);
	return { memberIds };
}

//#endregion
//#region src/hooks/use-space-mentions.ts
const emptyMentionsResult = [];
const EMPTY_SPACE_MENTIONS = new Observable({ mentionsMap: {} });
function useSpaceMentionsStore(selector) {
	const spaceMentions = useTownsContext()?.casablancaClient?.streamsView.my.spaceMentions ?? EMPTY_SPACE_MENTIONS;
	return useObservableWith(spaceMentions, selector);
}
function useSpaceMentions(spaceId) {
	return useSpaceMentionsStore(useCallback((state) => spaceId ? state.mentionsMap[spaceId]?.mentions ?? emptyMentionsResult : emptyMentionsResult, [spaceId]));
}
function useSpaceUnreadThreadMentions(spaceId) {
	return useSpaceMentionsStore(useCallback((state) => spaceId ? state.mentionsMap[spaceId]?.unreadThreadCount ?? 0 : 0, [spaceId]));
}
function useSpaceUnreadChannelMentions(spaceId) {
	return useSpaceMentionsStore(useCallback((state) => spaceId ? state.mentionsMap[spaceId]?.unreadChannelCount ?? 0 : 0, [spaceId]));
}

//#endregion
//#region src/hooks/use-space-notification-counts.ts
function useSpaceNotificationCounts(spaceId) {
	const { spaceUnreads, spaceMentions } = useSpaceUnreads();
	const isUnread = spaceUnreads[spaceId] ?? false;
	const mentions = spaceMentions[spaceId] ?? 0;
	return {
		isUnread,
		mentions
	};
}

//#endregion
//#region src/hooks/use-space-unread.ts
function useSpaceUnread() {
	const spaceId = useSpaceId();
	const { spaceUnreads } = useSpaceUnreads();
	if (!spaceId) return false;
	return spaceUnreads[spaceId] ?? false;
}

//#endregion
//#region src/hooks/use-space-timeline.ts
function useSpaceTimeline() {
	const { spaceId } = useSpaceContext();
	return useTimeline(spaceId);
}

//#endregion
//#region src/hooks/use-stream-encryption-algorithm.ts
const useStreamEncryptionAlgorithm = (streamId) => {
	const { casablancaClient } = useTownsContext();
	const [streamEncryptionAlgorithm, setStreamEncryptionAlgorithm] = useState(void 0);
	const setEncryptionAlgorithm = useCallback((algorithm) => {
		if (!casablancaClient) return;
		if (!streamId) return;
		casablancaClient.setStreamEncryptionAlgorithm(streamId, algorithm).then(() => {
			setStreamEncryptionAlgorithm(algorithm);
		}).catch((e) => {
			console.error("failed to set stream encryption algorithm", e);
		});
	}, [casablancaClient, streamId]);
	useEffect(() => {
		if (!casablancaClient) return;
		const onStreamUpdated = (updatedStreamId) => {
			if (updatedStreamId !== streamId) return;
			const stream = casablancaClient.streams.get(streamId);
			setStreamEncryptionAlgorithm(stream?._view.membershipContent.encryptionAlgorithm);
		};
		if (streamId) onStreamUpdated(streamId);
		casablancaClient.on("streamEncryptionAlgorithmUpdated", onStreamUpdated);
		return () => {
			casablancaClient.off("streamEncryptionAlgorithmUpdated", onStreamUpdated);
		};
	}, [
		casablancaClient,
		setStreamEncryptionAlgorithm,
		streamId
	]);
	return {
		streamEncryptionAlgorithm,
		setEncryptionAlgorithm
	};
};

//#endregion
//#region src/hooks/use-stream-up-to-date.ts
const useStreamUpToDate = (streamId) => {
	const { casablancaClient } = useTownsContext();
	const [upToDate, setUpToDate] = useState(() => streamId && casablancaClient && casablancaClient.streams.get(streamId)?.isUpToDate === true);
	useEffect(() => {
		if (!casablancaClient) return;
		const onUpToDate = (updatedStreamId) => {
			if (updatedStreamId !== streamId) return;
			const stream = casablancaClient.streams.get(streamId);
			setUpToDate(stream?.isUpToDate ?? false);
		};
		const onStreamSyncActive = (_active) => {
			if (streamId) onUpToDate(streamId);
		};
		if (streamId) onUpToDate(streamId);
		casablancaClient.on("streamUpToDate", onUpToDate);
		casablancaClient.on("streamSyncActive", onStreamSyncActive);
		return () => {
			casablancaClient.off("streamUpToDate", onUpToDate);
			casablancaClient.off("streamSyncActive", onStreamSyncActive);
		};
	}, [
		casablancaClient,
		setUpToDate,
		streamId
	]);
	return { upToDate };
};

//#endregion
//#region src/hooks/use-timeline-thread-stats.ts
const EMPTY_THREAD_STATS = new Set();
function useTimelineThreadStats(roomId) {
	const previous = useRef(new Set());
	const threadStats = useThrottledTimelineStore(useCallback((state) => roomId ? state.threadsStats[roomId] : void 0, [roomId]), 100);
	return useMemo(() => {
		if (!threadStats) return EMPTY_THREAD_STATS;
		const newKeys = new Set(Object.keys(threadStats));
		if (!isEqual(previous.current, newKeys)) previous.current = newKeys;
		return previous.current;
	}, [threadStats]);
}

//#endregion
//#region src/types/towns-types.ts
function isUpdateChannelAccessInfo(info) {
	return "disabled" in info && !("updatedChannelName" in info || "updatedRoleIds" in info);
}
function isMentionedTextMessageOptions(options) {
	return "mentions" in options && Array.isArray(options.mentions) && options.mentions.length > 0;
}
function isThreadIdOptions(options) {
	return "threadId" in options && typeof options.threadId === "string";
}

//#endregion
//#region src/query/removeSyncedEntitledChannelQueries.ts
function removeSyncedEntitledChannelsQueriesForSpace(spaceId) {
	const state = queryClient.getQueryState(blockchainKeys.entitledChannels(spaceId));
	if (!state?.fetchStatus || state?.fetchStatus === "idle") queryClient.removeQueries({ queryKey: blockchainKeys.entitledChannels(spaceId) });
}

//#endregion
//#region src/hooks/use-update-channel-transaction.ts
/**
* Hook to update a channel with a transaction.
*/
function useUpdateChannelTransaction() {
	const { clientSingleton, updateChannelRoom } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useUpdateChannelTransaction",
		execute: async ({ updateChannelInfo, signer, transactionType = BlockchainTransactionType.EditChannel }) => {
			removeSyncedEntitledChannelsQueriesForSpace(updateChannelInfo.parentSpaceId);
			return baseTransactor.createTransaction({
				debugName: "updateChannelTransaction",
				type: transactionType,
				signer,
				contextData: updateChannelInfo,
				preExecute: () => {
					let updateChannelParams;
					if (isUpdateChannelAccessInfo(updateChannelInfo)) updateChannelParams = {
						spaceId: updateChannelInfo.parentSpaceId,
						channelId: updateChannelInfo.channelId,
						disabled: updateChannelInfo.disabled
					};
					else if (updateChannelInfo?.updatedChannelName && updateChannelInfo?.updatedRoleIds) updateChannelParams = {
						spaceId: updateChannelInfo.parentSpaceId,
						channelId: updateChannelInfo.channelId,
						channelName: updateChannelInfo.updatedChannelName,
						channelDescription: updateChannelInfo.updatedChannelTopic ?? "",
						roleIds: updateChannelInfo.updatedRoleIds
					};
					return Promise.resolve(updateChannelParams);
				},
				aaExecute: (updateChannelParams) => {
					if (!baseTransactor.userOps) throw new Error("UserOps not initialized");
					if (updateChannelParams) return baseTransactor.userOps.sendUpdateChannelOp([updateChannelParams, signer]);
				},
				eoaExecute: (updateChannelParams) => {
					if (updateChannelParams) return baseTransactor.spaceDapp.updateChannel(updateChannelParams, signer);
				},
				errorDecoder: (error) => baseTransactor.getDecodedErrorForSpace(updateChannelInfo.parentSpaceId, error)
			});
		},
		waitForTransaction: async (context) => {
			if (!clientSingleton) throw new Error("Client singleton not initialized");
			const txContext = await baseTransactor.waitForBlockchainTransaction(context);
			if (!txContext) throw new Error("Transaction context not found");
			if (txContext.status === TransactionStatus.Success && txContext.data) await updateChannelRoom(txContext.data);
			return txContext;
		},
		invalidateQueries: (params) => [blockchainKeys.spaceAndChannel(params.updateChannelInfo.parentSpaceId, params.updateChannelInfo.channelId)]
	});
	return {
		...tx,
		updateChannelTransaction: tx.execute
	};
}

//#endregion
//#region src/hooks/use-update-role-transaction.ts
/**
* Hook to update a role with a transaction.
*/
function useUpdateRoleTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useUpdateRoleTransaction",
		execute: async ({ spaceNetworkId, roleId, roleName, permissions, users, ruleData, signer }) => {
			return baseTransactor.updateRoleTransaction(spaceNetworkId, roleId, roleName, permissions, users, ruleData, signer);
		},
		invalidateQueries: (params) => [blockchainKeys.roleDetails(params.spaceNetworkId, params.roleId)]
	});
	return {
		...tx,
		updateRoleTransaction: tx.execute
	};
}

//#endregion
//#region src/hooks/use-update-space-info-transaction.ts
/**
* Hook to update space name with a transaction.
*/
function useUpdateSpaceInfoTransaction(props) {
	const { baseTransactor } = useBaseWrites();
	const { getSpaceInfo: getSpaceInfo$1 } = useBaseReads();
	const spaceInfoCache = useMutationSpaceInfoCache({ onSuccess: props?.onSuccess });
	const tx = useTransaction({
		debugName: "useUpdateSpaceInfoTransaction",
		execute: async ({ spaceNetworkId, name, uri, shortDescription, longDescription, signer }) => {
			const spaceInfo = await getSpaceInfo$1(spaceNetworkId);
			const _inUri = uri?.length > 0 ? uri : void 0;
			const _currentUri = spaceInfo && spaceInfo.uri?.length > 0 ? spaceInfo.uri : " ";
			const args = {
				spaceId: spaceNetworkId,
				name,
				uri: _inUri ?? _currentUri,
				shortDescription: shortDescription ?? spaceInfo?.shortDescription ?? "",
				longDescription: longDescription ?? spaceInfo?.longDescription ?? "",
				signer
			};
			return baseTransactor.createTransaction({
				debugName: "updateSpaceInfoTransaction",
				type: BlockchainTransactionType.UpdateSpaceInfo,
				signer,
				contextData: { spaceStreamId: spaceNetworkId },
				aaExecute: async () => {
					if (!baseTransactor.userOps) throw new Error("userOps not found");
					return baseTransactor.userOps?.sendUpdateSpaceInfoOp(args);
				},
				eoaExecute: async () => {
					return baseTransactor.spaceDapp.spaceOwner.updateSpaceInfo(args);
				},
				errorDecoder: (error) => baseTransactor.getDecodedErrorForSpace(spaceNetworkId, error)
			});
		},
		onSuccess: async (params) => {
			const spaceInfo = await getSpaceInfo$1(params.spaceNetworkId);
			spaceInfoCache.mutate(spaceInfo);
		}
	});
	return {
		...tx,
		updateSpaceInfoTransaction: tx.execute
	};
}

//#endregion
//#region src/hooks/use-edit-space-membership-transaction.ts
function useEditSpaceMembershipTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		execute: async ({ spaceId, updateRoleParams, membershipParams, signer }) => {
			if (!signer) throw new SignerUndefinedError();
			return baseTransactor.createTransaction({
				contextData: { spaceStreamId: spaceId },
				debugName: "editSpaceMembershipTransaction",
				type: BlockchainTransactionType.EditSpaceMembership,
				signer,
				preExecute: async () => {
					const isLegacySpace = await baseTransactor.spaceDapp.isLegacySpace(spaceId);
					return {
						legacyUpdateRoleParams: isLegacySpace ? {
							...updateRoleParams,
							ruleData: convertRuleDataV2ToV1(updateRoleParams.ruleData)
						} : void 0,
						updateRoleParams: isLegacySpace ? void 0 : updateRoleParams
					};
				},
				aaExecute: async ({ legacyUpdateRoleParams, updateRoleParams: updateRoleParams$1 }) => {
					if (!baseTransactor.userOps) throw new Error("userOps not found");
					if (legacyUpdateRoleParams) return baseTransactor.userOps?.sendLegacyEditMembershipSettingsOp({
						spaceId,
						legacyUpdateRoleParams,
						membershipParams,
						signer
					});
					else if (updateRoleParams$1) return baseTransactor.userOps?.sendEditMembershipSettingsOp({
						spaceId,
						updateRoleParams: updateRoleParams$1,
						membershipParams,
						signer
					});
					throw new Error("No update role params provided");
				},
				eoaExecute: async ({ legacyUpdateRoleParams, updateRoleParams: updateRoleParams$1 }) => {
					if (legacyUpdateRoleParams) return baseTransactor.spaceDapp.legacyUpdateRole(legacyUpdateRoleParams, signer);
					else if (updateRoleParams$1) return baseTransactor.spaceDapp.updateRole(updateRoleParams$1, signer);
					throw new Error("No update role params provided");
				},
				errorDecoder: (error) => baseTransactor.getDecodedErrorForSpace(spaceId, error)
			});
		},
		invalidateQueries: (params) => [
			blockchainKeys.roleDetails(params.spaceId, 1),
			blockchainKeys.membershipInfo(params.spaceId),
			blockchainKeys.membershipPrice(params.spaceId),
			blockchainKeys.protocolFee(params.spaceId)
		],
		debugName: "useEditSpaceMembershipTransaction"
	});
	return {
		...tx,
		editSpaceMembershipTransaction: tx.execute
	};
}

//#endregion
//#region src/hooks/use-banning.ts
function useBanUnbanTransactionBuilder(executeFunction) {
	const { removeUser } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	const result = useTransaction({
		debugName: "useBanUnbanTransaction",
		execute: async ({ signer, spaceId, userId }) => {
			return executeFunction?.(spaceId, userId, signer);
		},
		waitForTransaction: async (transactionContext) => {
			const awaited = await baseTransactor.waitForBlockchainTransaction(transactionContext);
			if (awaited?.status === TransactionStatus.Success && awaited.data?.isBan) await removeUser(awaited.data.spaceId, awaited.data.userId);
			return awaited;
		},
		invalidateQueries: (params, data) => {
			if (data?.spaceId && data?.userId) return [blockchainKeys.walletAddressIsBanned(data.spaceId, data.userId), blockchainKeys.bannedWalletAddresses(data.spaceId)];
			return [blockchainKeys.walletAddressIsBanned(params.spaceId, params.userId), blockchainKeys.bannedWalletAddresses(params.spaceId)];
		}
	});
	const executeTransaction = useCallback(async function(signer, spaceId, userId) {
		if (!signer) throw new Error("Signer is undefined");
		return result.execute({
			signer,
			spaceId,
			userId
		});
	}, [result]);
	return {
		...result,
		executeTransaction
	};
}
function useBanTransaction() {
	const { baseTransactor } = useBaseWrites();
	const { executeTransaction,...rest } = useBanUnbanTransactionBuilder(baseTransactor.banTransaction.bind(baseTransactor));
	return {
		banTransaction: executeTransaction,
		...rest
	};
}
function useUnbanTransaction() {
	const { baseTransactor } = useBaseWrites();
	const { executeTransaction,...rest } = useBanUnbanTransactionBuilder(baseTransactor.unbanTransaction.bind(baseTransactor));
	return {
		unbanTransaction: executeTransaction,
		...rest
	};
}
function useWalletAddressIsBanned(spaceId, userId, opts) {
	const { walletAddressIsBanned } = useBaseReads();
	const userIsBanned = useCallback(async () => {
		if (!spaceId || !userId) return;
		return await walletAddressIsBanned(spaceId, userId, { skipCache: opts?.skipCache });
	}, [
		spaceId,
		userId,
		opts?.skipCache,
		walletAddressIsBanned
	]);
	const isEnabled = spaceId && userId ? spaceId.length > 0 && userId.length > 0 : false;
	const { data, isLoading, isFetching, isPending, isSuccess, error } = useQuery(blockchainKeys.walletAddressIsBanned(spaceId ?? "", userId ?? ""), userIsBanned, {
		enabled: isEnabled,
		refetchOnMount: true,
		...opts?.skipCache && {
			cacheTime: 0,
			staleTime: 0
		}
	});
	return {
		isBanned: data ?? false,
		isLoading,
		isFetching,
		isPending,
		isBusy: isLoading || isFetching || isPending,
		isSuccess,
		error
	};
}

//#endregion
//#region src/hooks/use-blocked-users.ts
const DEFAULT_OBSERVABLE$1 = new Observable(new Set());
function useBlockedUsers() {
	const { casablancaClient } = useTownsContext();
	const observable = casablancaClient?.streamsView.my.blockedUserIds ?? DEFAULT_OBSERVABLE$1;
	const blockedUserIds = useObservable(observable);
	return { blockedUserIds };
}

//#endregion
//#region src/hooks/use-bots-by-owner.ts
const USER_BOTS_QUERY = gql`
    query GetAppsByOwner($ownerAddress: String!) {
        apps(where: { owner: $ownerAddress }) {
            items {
                address
                createdAt
            }
        }
    }
`;
const useBotsByOwner = (ownerAddress) => {
	const { subgraphEndpoint } = useBaseReads();
	return useQuery(blockchainKeys.myBots(), async () => {
		if (!subgraphEndpoint || !ownerAddress) return [];
		try {
			const data = await request(subgraphEndpoint, USER_BOTS_QUERY, { ownerAddress });
			return data?.apps?.items ?? [];
		} catch (error) {
			console.error("[useBotsByOwner] Error fetching bots by owner:", error);
			return [];
		}
	}, {
		enabled: !!ownerAddress && !!subgraphEndpoint,
		staleTime: 1e3 * 60 * 15,
		refetchOnWindowFocus: false
	});
};

//#endregion
//#region src/hooks/use-sanctioned-addresses.ts
const SANCTIONS_BASE_URL = "https://raw.githubusercontent.com/0xB10C/ofac-sanctioned-digital-currency-addresses/refs/heads/lists";
const CHAIN_LISTS = [
	"ETH",
	"BSC",
	"ARB",
	"USDC",
	"USDT",
	"ETC"
];
const sanctionsQueryKey = () => ["sanctions"];
const TEST_ADDRESSES = ["0x4B1809aEA0Ef8033F1d04C4947B4fbe0e04C67ee", "0x49d04e5d030019146B81f55556628DaA5bE6DF13"].map((addr) => addr.toLowerCase());
const fetchSanctionedAddresses = async () => {
	try {
		console.log("Fetching sanctions from all chains via GitHub");
		const fetchPromises = CHAIN_LISTS.map(async (chain) => {
			try {
				const response = await fetch(`${SANCTIONS_BASE_URL}/sanctioned_addresses_${chain}.json`);
				if (!response.ok) {
					console.warn(`Failed to fetch sanctions for ${chain}: ${response.statusText}`);
					return [];
				}
				return await response.json();
			} catch (error) {
				console.warn(`Error fetching ${chain} sanctions:`, error);
				return [];
			}
		});
		const results = await Promise.all(fetchPromises);
		const allAddresses = results.flatMap((addr) => addr.filter((a) => a.startsWith("0x")).map((a) => a.toLowerCase()));
		const uniqueAddresses = new Set([...allAddresses, ...TEST_ADDRESSES]);
		console.info(`Sanctions fetch complete. Combined ${allAddresses.length} addresses into ${uniqueAddresses.size} unique addresses (including ${TEST_ADDRESSES.length} test addresses)`);
		return uniqueAddresses;
	} catch (error) {
		console.error("Failed to fetch sanctioned addresses:", error);
		return new Set([]);
	}
};
function useSanctionedAddresses() {
	const { data: sanctionedAddresses, isLoading } = useQuery(sanctionsQueryKey(), fetchSanctionedAddresses, {
		staleTime: 60 * 60 * 1e3 * 24,
		retry: 3
	});
	const isSanctioned = (address) => {
		if (!sanctionedAddresses) return false;
		return sanctionedAddresses.has(address.toLowerCase());
	};
	return {
		isSanctioned,
		isLoading
	};
}

//#endregion
//#region src/hooks/use-linked-wallets.ts
function useLinkEOAToRootKeyTransaction({ onSuccess, onError } = {}) {
	const { baseTransactor } = useBaseWrites();
	const { isSanctioned, isLoading: isSanctionsListLoading } = useSanctionedAddresses();
	const { loggedInWalletAddress } = useConnectivity();
	const result = useTransaction({
		debugName: "useLinkEOAToRootKeyTransaction",
		execute: async ({ signer,...params }) => {
			const { wallet } = params;
			const address = await wallet.getAddress();
			if (isSanctioned(address.toLowerCase())) throw new Error("This wallet has been blocked by OFAC's Sanctions List");
			return await baseTransactor.linkEOAToRootKey(signer, wallet);
		},
		invalidateQueries: () => {
			return loggedInWalletAddress ? [blockchainKeys.linkedWallets(loggedInWalletAddress), blockchainKeys.linkedWalletsWithDelegations(loggedInWalletAddress)] : [];
		},
		onSuccess: async () => {
			await onSuccess?.();
		},
		onError: async (error) => {
			await onError?.(error);
		}
	});
	const isLoading = useMemo(() => {
		return result.isLoading || isSanctionsListLoading;
	}, [result.isLoading, isSanctionsListLoading]);
	return {
		...result,
		isLoading,
		linkEOAToRootKeyTransaction: useCallback(async function(rootKey, wallet) {
			if (!rootKey || !wallet) {
				const error = new Error("Signer is undefined");
				await onError?.(error);
				throw error;
			}
			return result.execute({
				signer: rootKey,
				wallet
			});
		}, [result, onError])
	};
}
/**
* Only use this to link the smart account
* @returns
*/
function useLinkCallerToRootKey() {
	const { baseTransactor } = useBaseWrites();
	const { loggedInWalletAddress } = useConnectivity();
	const result = useTransaction({
		debugName: "useLinkCallerToRootKey",
		execute: async ({ signer }) => {
			return baseTransactor.linkCallerToRootKey(signer);
		},
		invalidateQueries: () => {
			return loggedInWalletAddress ? [blockchainKeys.linkedWallets(loggedInWalletAddress), blockchainKeys.linkedWalletsWithDelegations(loggedInWalletAddress)] : [];
		}
	});
	return {
		...result,
		linkCallerToRootKeyTransaction: useCallback(async function(rootKey) {
			if (!rootKey) throw new Error("Signer is undefined");
			return result.execute({ signer: rootKey });
		}, [result])
	};
}
function useUnlinkWalletTransaction() {
	const { clientSingleton } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	const { loggedInWalletAddress } = useConnectivity();
	const result = useTransaction({
		debugName: "useUnlinkWalletTransaction",
		execute: async ({ signer,...params }) => {
			const { walletAddress } = params;
			return baseTransactor.unlinkViaRootKey(signer, walletAddress);
		},
		onSuccess: (_context, params) => {
			if (params.data?.rootKeyAddress) clientSingleton?.emit("onWalletUnlinked", params.data.rootKeyAddress, params.data.walletAddress);
		},
		invalidateQueries: () => {
			return loggedInWalletAddress ? [blockchainKeys.linkedWallets(loggedInWalletAddress), blockchainKeys.linkedWalletsWithDelegations(loggedInWalletAddress)] : [];
		}
	});
	return {
		...result,
		unlinkWalletTransaction: useCallback(async function(rootKey, walletAddress) {
			if (!rootKey || !walletAddress) throw new Error("Signer or wallet address is undefined");
			return result.execute({
				signer: rootKey,
				walletAddress
			});
		}, [result])
	};
}
function useUnlinkViaCallerTransaction() {
	const { baseTransactor } = useBaseWrites();
	const { loggedInWalletAddress } = useConnectivity();
	const result = useTransaction({
		debugName: "useUnlinkViaCallerTransaction",
		execute: async ({ signer }) => {
			return baseTransactor.unlinkViaCaller(signer);
		},
		waitForTransaction: async (context) => {
			return baseTransactor.waitForBlockchainTransaction(context, void 0, 2);
		},
		invalidateQueries: () => {
			return loggedInWalletAddress ? [blockchainKeys.linkedWallets(loggedInWalletAddress), blockchainKeys.linkedWalletsWithDelegations(loggedInWalletAddress)] : [];
		}
	});
	return {
		...result,
		unlinkViaCallerTransaction: useCallback(async function(caller) {
			return result.execute({ signer: caller });
		}, [result])
	};
}

//#endregion
//#region src/hooks/use-supported-xchain-ids.ts
function useSupportedXChainIds() {
	const { baseChain } = useTownsContext();
	return useMemo(() => getDefaultXChainIds(baseChain.id), [baseChain.id]);
}

//#endregion
//#region src/hooks/use-unjoined-channel-members.ts
const CACHE_PREFIX = "unjoined-channel-members";
const CACHE_EXPIRY_MS = 1 * 60 * 1e3;
/**
* Returns function to get members from unjoined streams and caches the results
*/
function useUnjoinedChannelMembers() {
	const { casablancaClient } = useTownsContext();
	async function getUnjoinedChannelMembers(roomId) {
		const cacheKeyTimestamp = `${CACHE_PREFIX}/roomId/${roomId}/timestamp`;
		const cachedTimestamp = sessionStorage.getItem(cacheKeyTimestamp);
		if (cachedTimestamp) {
			const timestamp = parseInt(cachedTimestamp, 10);
			if (Date.now() - timestamp > CACHE_EXPIRY_MS) sessionStorage.removeItem(`${CACHE_PREFIX}/roomId/${roomId}`);
		}
		const cacheKey = `${CACHE_PREFIX}/roomId/${roomId}`;
		const cachedData = sessionStorage.getItem(cacheKey);
		if (cachedData) return JSON.parse(cachedData);
		const memberIdsArray = await fetchStreamMembers(roomId);
		sessionStorage.setItem(cacheKey, JSON.stringify(memberIdsArray));
		sessionStorage.setItem(cacheKeyTimestamp, Date.now().toString());
		return memberIdsArray;
	}
	const fetchStreamMembers = async (roomId) => {
		const stream = await casablancaClient?.getStream(roomId);
		const memberIdsArray = Array.from(stream?.getMembers().joinedUsers.values() ?? []);
		return memberIdsArray;
	};
	return getUnjoinedChannelMembers;
}

//#endregion
//#region src/hooks/use-set-channel-autojoin.ts
function useSetChannelAutojoin({ onSuccess, onError } = {}) {
	const { client } = useTownsClient();
	return useMutation({
		mutationFn: async (args) => {
			const { spaceId, channelId, autojoin } = args;
			await client?.setChannelAutojoin(spaceId, channelId, autojoin);
		},
		onError: (error) => {
			onError?.(error);
		},
		onSuccess: () => {
			onSuccess?.();
		}
	});
}

//#endregion
//#region src/hooks/use-set-hide-user-join-leave.ts
function useSetHideUserJoinLeave({ onSuccess, onError } = {}) {
	const { client } = useTownsClient();
	return useMutation({
		mutationFn: async (args) => {
			const { spaceId, channelId, hideEvents } = args;
			await client?.setChannelHideUserJoinLeaveEvents(spaceId, channelId, hideEvents);
		},
		onError: (error) => {
			onError?.(error);
		},
		onSuccess: () => {
			onSuccess?.();
		}
	});
}

//#endregion
//#region src/hooks/use-transfer-asset-transaction.ts
/**
* Hook to transfer assets with a transaction.
*/
function useTransferAssetTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useTransferAssetTransaction",
		execute: async ({ data, signer }) => baseTransactor.transferAsset(data, signer)
	});
	return {
		...tx,
		transferAsset: tx.execute
	};
}

//#endregion
//#region src/hooks/use-add-space-delegation-transaction.ts
/**
* delegates staking within a space to a node operator
*/
function useAddSpaceDelegationTransaction() {
	const { userOpsInstance: userOps, baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		execute: async ({ spaceId, operatorAddress, signer }) => baseTransactor.createTransaction({
			signer,
			type: BlockchainTransactionType.AddSpaceDelegation,
			debugName: "addSpaceDelegationTransaction",
			contextData: {
				spaceId,
				operatorAddress
			},
			aaExecute: () => {
				if (!userOps) throw new Error("userOps is not initialized");
				return userOps?.sendAddSpaceDelegationOp({
					spaceId,
					operatorAddress,
					signer
				});
			},
			eoaExecute: () => {
				return baseTransactor.spaceDapp.addSpaceDelegation({
					spaceId,
					operatorAddress,
					signer
				});
			},
			errorDecoder: (err) => {
				return baseTransactor.getDecodedErrorForSpace(spaceId, err);
			}
		}),
		waitForTransaction: (context) => {
			return baseTransactor.waitForBlockchainTransaction(context, void 0, 2);
		},
		invalidateQueries: (params) => [blockchainKeys.delegationDataBySpace(params.spaceId), blockchainKeys.delegationDataByOperator(params.operatorAddress)],
		debugName: "useAddSpaceDelegationTransaction"
	});
	const addSpaceDelegation = useCallback(async (args, callbacks = {}) => {
		const transactionResult = await tx.execute(args);
		if (transactionResult?.status === TransactionStatus.Success) callbacks.onSuccess?.();
		else if (transactionResult?.error) callbacks.onError?.(transactionResult.error);
		return transactionResult;
	}, [tx]);
	return {
		...tx,
		addSpaceDelegation
	};
}

//#endregion
//#region src/hooks/use-stake-to-town-transaction.ts
/**
* delegates staking within a space to a node operator
*/
function useStakeToTownTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useStakeToTownTransaction",
		execute: (params) => {
			const { signer, amount, delegatee, operatorAddress, beneficiary } = params;
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.StakeToTowns,
				debugName: "stakeToTownTransaction",
				contextData: {
					amount,
					delegatee,
					operatorAddress,
					beneficiary
				},
				aaExecute: () => {
					if (!baseTransactor.userOps) throw new Error("userOps is not initialized");
					return baseTransactor.userOps?.sendStakeToTownOp({
						amount,
						delegatee,
						operatorAddress,
						beneficiary,
						signer
					});
				},
				eoaExecute: () => {
					throw new Error("stake to town with EOA is not supported");
				},
				errorDecoder: (err) => {
					let error = baseTransactor.getDecodedErrorForRewardsDistributionV2(err);
					if (!error || error.name === "UNKNOWN_ERROR") error = baseTransactor.parseSpaceDelegationError({
						message: "Failed to stake to town",
						originalError: err
					});
					return error;
				}
			});
		},
		waitForTransaction: (context) => {
			return baseTransactor.waitForBlockchainTransaction(context, void 0, 2);
		},
		invalidateQueries: (params) => {
			const queries = [
				blockchainKeys.townsTokenBalance(),
				blockchainKeys.myStakingDeposits(),
				blockchainKeys.delegationDataBySpace(params.delegatee),
				blockchainKeys.stakingReputationByUser()
			];
			if (params.operatorAddress) queries.push(blockchainKeys.delegationDataByOperator(params.operatorAddress));
			return queries;
		}
	});
	const stakeToTown = useCallback(async (args, callbacks) => {
		const result = await tx.execute(args);
		if (result?.status === TransactionStatus.Success) callbacks?.onSuccess?.();
		else if (result?.status === TransactionStatus.Failed) callbacks?.onError?.(result.error);
		return result;
	}, [tx]);
	return {
		...tx,
		stakeToTown
	};
}

//#endregion
//#region src/hooks/use-increase-stake-to-town-transaction.ts
/**
* increases stake for an existing deposit
*/
function useIncreaseStakeToTownTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		execute: async (params) => {
			return baseTransactor.createTransaction({
				signer: params.signer,
				type: BlockchainTransactionType.IncreaseStakeToTowns,
				debugName: "increaseStakeToTownTransaction",
				contextData: {
					depositId: params.depositId,
					amount: params.amount
				},
				aaExecute: () => {
					if (!baseTransactor.userOps) throw new Error("userOps is not initialized");
					return baseTransactor.userOps?.sendIncreaseStakeToTownOp({
						depositId: params.depositId,
						amount: params.amount,
						signer: params.signer
					});
				},
				eoaExecute: () => {
					throw new Error("increase stake to town with EOA is not supported");
				},
				errorDecoder: (err) => {
					return baseTransactor.getDecodedErrorForRewardsDistributionV2(err) ?? new Error("Unknown RewardsDistributionV2 error");
				}
			});
		},
		waitForTransaction: (context) => {
			return baseTransactor.waitForBlockchainTransaction(context, void 0, 2);
		},
		invalidateQueries: (_, data) => [
			blockchainKeys.townsTokenBalance(),
			blockchainKeys.myStakingDeposits(),
			blockchainKeys.stakingReputationByUser(),
			...data?.depositId ? [blockchainKeys.stakingDepositDetails(data.depositId)] : []
		],
		debugName: "useIncreaseStakeToTownTransaction"
	});
	const increaseStakeToTown = useCallback(async (args, callbacks = {}) => {
		const transactionResult = await tx.execute(args);
		if (transactionResult?.status === TransactionStatus.Success) callbacks.onSuccess?.();
		else if (transactionResult?.error) callbacks.onError?.(transactionResult.error);
		return transactionResult;
	}, [tx]);
	return {
		...tx,
		increaseStakeToTown
	};
}

//#endregion
//#region src/hooks/use-initiate-withdraw-transaction.ts
function useInitiateWithdrawTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		execute: async (params) => {
			return baseTransactor.createTransaction({
				signer: params.signer,
				type: BlockchainTransactionType.InitiateWithdraw,
				contextData: { depositIds: params.depositIds },
				debugName: "initiateWithdraw",
				aaExecute: async () => {
					if (!baseTransactor.userOps) throw new Error("UserOps not initialized");
					return baseTransactor.userOps.sendInitiateWithdrawOp({
						depositIds: params.depositIds,
						signer: params.signer
					});
				},
				eoaExecute: () => {
					throw new Error("EOA not supported for initiateWithdraw");
				},
				errorDecoder: (error) => {
					return baseTransactor.getDecodedErrorForRewardsDistributionV2(error) ?? new Error("Error initiating withdraw");
				}
			});
		},
		invalidateQueries: (params) => [blockchainKeys.myStakingDeposits(), ...params.depositIds.map((depositId) => blockchainKeys.stakingDepositDetails(depositId))],
		debugName: "useInitiateWithdrawTransaction"
	});
	const initiateWithdraw = useCallback(async (args) => {
		const { onSuccess, onError,...params } = args;
		const transactionResult = await tx.execute(params);
		if (transactionResult?.status === TransactionStatus.Success) onSuccess?.();
		else if (transactionResult?.error) onError?.(transactionResult.error);
		return transactionResult;
	}, [tx]);
	return {
		...tx,
		initiateWithdraw
	};
}

//#endregion
//#region src/hooks/use-withdraw-transaction.ts
function useWithdrawTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useWithdrawTransaction",
		execute: async (params) => {
			return baseTransactor.createTransaction({
				signer: params.signer,
				type: BlockchainTransactionType.Withdraw,
				contextData: { delegatee: params.delegatee ?? zeroAddress },
				debugName: "withdraw",
				aaExecute: async () => {
					if (!baseTransactor.userOps) throw new Error("UserOps not initialized");
					return baseTransactor.userOps.sendWithdrawOp({
						depositIds: params.depositIds,
						signer: params.signer
					});
				},
				eoaExecute: () => {
					throw new Error("EOA not supported for withdraw");
				},
				errorDecoder: (error) => {
					return baseTransactor.getDecodedErrorForRewardsDistributionV2(error) ?? new Error("Error withdrawing");
				}
			});
		},
		invalidateQueries: (params) => {
			const queries = [
				blockchainKeys.myStakingDeposits(),
				blockchainKeys.townsTokenBalance(),
				blockchainKeys.stakingReputationByUser(params.userId)
			];
			for (const depositId of params.depositIds) queries.push(blockchainKeys.stakingDepositDetails(depositId));
			return queries;
		}
	});
	return {
		...tx,
		withdraw: tx.execute
	};
}
const useDepositsUnlockDate = (depositIds) => {
	const { spaceDapp } = useTownsClient();
	return useQueries({ queries: depositIds.map((depositId) => ({
		queryKey: blockchainKeys.stakingDepositUnlockDate(depositId.toString()),
		queryFn: async () => {
			const delegationProxy = await spaceDapp?.baseRegistry.rewardsDistributionV2.read.delegationProxyById(depositId);
			if (!delegationProxy) return void 0;
			const expiration = await spaceDapp?.townsToken?.read.lockExpiration(delegationProxy.toString());
			if (!expiration) return void 0;
			return expiration.toNumber() * 1e3;
		}
	})) });
};

//#endregion
//#region src/store/use-optimistic-tips-store.ts
try {
	const OPTIMISTIC_TIPS_KEY = "towns/optimisticTips";
	const TIP_COUNT_HIGH_WATER_MARKS_KEY = "towns/tipCountHighWaterMarks";
	localStorage.removeItem(OPTIMISTIC_TIPS_KEY);
	localStorage.removeItem(TIP_COUNT_HIGH_WATER_MARKS_KEY);
} catch (error) {}
const useOptimisticTipsStore = create()(persist((set, get) => ({
	tips: [],
	highWaterMarks: {},
	addTip: (recipientId, currencyToAmounts) => {
		set((state) => {
			const now = Date.now();
			const fifteenMinutes = 15 * 60 * 1e3;
			const validTips = state.tips.filter((tip) => now - tip.timestamp < fifteenMinutes);
			const newTips = [...validTips, {
				recipientId,
				timestamp: now,
				currencyToAmounts
			}];
			return { tips: newTips };
		});
	},
	getTipsForRecipient: (recipientId) => {
		get().cleanExpiredTips();
		return get().tips.filter((tip) => tip.recipientId === recipientId).length;
	},
	getAmountsForRecipient: (recipientId) => {
		get().cleanExpiredTips();
		const tips = get().tips.filter((tip) => tip.recipientId === recipientId);
		const totalByCurrency = {};
		for (const tip of tips) for (const [currency, amount] of Object.entries(tip.currencyToAmounts)) {
			const current = BigInt(totalByCurrency[currency] || "0");
			const adding = BigInt(amount || "0");
			totalByCurrency[currency] = (current + adding).toString();
		}
		return totalByCurrency;
	},
	cleanExpiredTips: () => {
		const now = Date.now();
		const fifteenMinutes = 15 * 60 * 1e3;
		const currentTips = get().tips;
		const validTips = currentTips.filter((tip) => now - tip.timestamp < fifteenMinutes);
		const tipsRemoved = validTips.length !== currentTips.length;
		if (tipsRemoved) set({ tips: validTips });
		return tipsRemoved;
	},
	getHighWaterMarkForUser: (userId) => {
		return get().highWaterMarks[userId] || {
			tipCount: 0,
			ethAmount: "0",
			usdcAmount: "0"
		};
	},
	updateHighWaterMarkForUser: (userId, count, ethAmount, usdcAmount) => {
		set((state) => {
			const existing = state.highWaterMarks[userId];
			const existingCount = existing?.tipCount ?? 0;
			const existingEthAmount = BigInt(existing?.ethAmount ?? "0");
			const existingUsdcAmount = BigInt(existing?.usdcAmount ?? "0");
			if (count > existingCount || ethAmount > existingEthAmount || usdcAmount > existingUsdcAmount) return { highWaterMarks: {
				...state.highWaterMarks,
				[userId]: {
					tipCount: Math.max(count, existingCount),
					ethAmount: (ethAmount > existingEthAmount ? ethAmount : existingEthAmount).toString(),
					usdcAmount: (usdcAmount > existingUsdcAmount ? usdcAmount : existingUsdcAmount).toString()
				}
			} };
			return state;
		});
	},
	clearHighWaterMarkForUser: (userId) => {
		set((state) => {
			if (state.highWaterMarks[userId] !== void 0) {
				const { [userId]: _,...rest } = state.highWaterMarks;
				return { highWaterMarks: rest };
			}
			return state;
		});
	}
}), {
	name: "towns/useOptimisticTipsStore",
	version: 2,
	migrate: (state, version) => {
		if (version < 2) return {
			tips: [],
			highWaterMarks: {}
		};
		return state;
	},
	partialize: (state) => ({
		tips: state.tips,
		highWaterMarks: state.highWaterMarks
	})
}));

//#endregion
//#region src/hooks/use-tip-transaction.ts
/**
* Hook to create a tip transaction with optimistic updates.
*/
function useTipTransaction() {
	const { clientSingleton } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	const addOptimisticTip = useOptimisticTipsStore((state) => state.addTip);
	const tx = useTransaction({
		debugName: "useTipTransaction",
		execute: async (params) => {
			return baseTransactor.tipTransaction(params);
		},
		waitForTransaction: async (context) => {
			const awaitedTx = await baseTransactor.waitForBlockchainTransaction(context, void 0, 2);
			if (!awaitedTx) return createTransactionContext({
				status: TransactionStatus.Failed,
				error: new Error("No transaction found")
			});
			const receipt = awaitedTx.receipt;
			const chainId = clientSingleton?.spaceDapp?.config.chainId;
			if (awaitedTx.status === TransactionStatus.Success && receipt && chainId && awaitedTx.data) {
				const tipEvent = (() => {
					if (awaitedTx.data.type === "any") {
						const provider = clientSingleton?.spaceDapp?.provider;
						const accountModulesAddress = clientSingleton?.spaceDapp?.config.addresses.accountModules;
						if (!provider || !accountModulesAddress) return void 0;
						const tippingShim = new ITippingShim(accountModulesAddress, provider);
						return tippingShim.getTipEvent(receipt, awaitedTx.data.senderAddress);
					}
					if (!awaitedTx.data.spaceId) return void 0;
					return clientSingleton?.spaceDapp?.getTipEvent(awaitedTx.data.spaceId, receipt, awaitedTx.data.senderAddress);
				})();
				const toUserId = awaitedTx.data.receiverUserId;
				if (tipEvent) try {
					await retryOperation(async () => {
						await clientSingleton?.casablancaClient?.addTransaction_Tip(chainId, receipt, tipEvent, toUserId);
					}, {
						onError: (error, retryCount) => {
							console.log("[waitForTipTransaction::addTransaction_Tip] error", {
								error,
								retryCount
							});
						},
						onRetry: (retryCount) => {
							console.log("[waitForTipTransaction::addTransaction_Tip] retrying", { retryCount });
						}
					});
				} catch (error) {
					console.error("waitForTipTransaction:: Failed to add transaction_tip", error);
				}
				else console.error("waitForTipTransaction:: No tip event found");
			}
			return awaitedTx;
		},
		optimisticUpdate: { apply: (params) => {
			addOptimisticTip(params.receiverUserId, { [params.currency]: params.amount.toString() });
		} },
		invalidateQueries: (params) => {
			if (params.type === "any") return [];
			return [blockchainKeys.spaceTotalTips(params.spaceId)];
		}
	});
	const tip = useCallback(async (params, { onSuccess, onError }) => {
		const result = await tx.execute(params);
		if (result?.status === TransactionStatus.Success) {
			if (result.data) {
				const tipEvent = (() => {
					if (params.type === "any") {
						const provider = clientSingleton?.spaceDapp?.provider;
						const accountModulesAddress = clientSingleton?.spaceDapp?.config.addresses.accountModules;
						if (!provider || !accountModulesAddress) return void 0;
						const tippingShim = new ITippingShim(accountModulesAddress, provider);
						return tippingShim.getTipEvent(result.receipt, result.data.senderAddress);
					}
					return clientSingleton?.spaceDapp.getTipEvent(params.spaceId, result.receipt, result.data.senderAddress);
				})();
				if (tipEvent) onSuccess?.(tipEvent);
			}
		} else if (result?.status === TransactionStatus.Failed) onError?.(result.error);
		return result;
	}, [clientSingleton?.spaceDapp, tx]);
	return {
		...tx,
		tip
	};
}

//#endregion
//#region src/hooks/use-checkin-transaction.ts
function useCheckInTransaction() {
	const { userOpsInstance: userOps, baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useCheckInTransaction",
		execute: async (args) => {
			return baseTransactor.createTransaction({
				signer: args.signer,
				type: BlockchainTransactionType.CheckIn,
				debugName: "useCheckInTransaction",
				aaExecute: async () => {
					if (!userOps) throw new Error("UserOps is not initialized");
					return userOps.sendCheckInOp([args.signer]);
				},
				eoaExecute: async () => {
					if (!baseTransactor.spaceDapp.airdrop) throw new Error("[useCheckInTransaction] Airdrop is not initialized");
					const tx$1 = await baseTransactor.spaceDapp.airdrop.checkIn(args.signer);
					if (!tx$1) throw new Error("[useCheckInTransaction] Transaction is not created");
					return tx$1;
				},
				errorDecoder: (error) => baseTransactor.getDecodedErrorForRiverPoints(error) ?? error
			});
		}
	});
	return {
		...tx,
		checkIn: tx.execute
	};
}

//#endregion
//#region src/hooks/use-review-transaction.ts
/**
* Hook to handle review transactions.
*/
function useReviewTransaction() {
	const { addSpaceReview } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	const { spaceDapp } = useBaseReads();
	const tx = useTransaction({
		debugName: "useReviewTransaction",
		execute: async (args) => {
			const { signer,...reviewParams } = args;
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.Review,
				contextData: reviewParams,
				debugName: "review",
				aaExecute: async () => {
					if (!baseTransactor.userOps) throw new Error("UserOps not initialized");
					return baseTransactor.userOps.sendReviewOp([args, signer]);
				},
				eoaExecute: async () => {
					let transaction = void 0;
					const space = spaceDapp.getSpace(reviewParams.spaceId);
					if (!space) throw new Error(`Space with spaceId "${reviewParams.spaceId}" is not found.`);
					if (reviewParams.isDelete) transaction = await space.Review.deleteReview(signer);
					else transaction = reviewParams.isUpdate ? await space.Review.updateReview(reviewParams, signer) : await space.Review.addReview(reviewParams, signer);
					return transaction;
				},
				errorDecoder: (error) => {
					return baseTransactor.tryDecodeError(error, "Failed to submit review");
				}
			});
		},
		waitForTransaction: async (context) => {
			const txnContext = await baseTransactor.waitForBlockchainTransaction(context, void 0, 2);
			return addSpaceReview(txnContext);
		},
		invalidateQueries: (params) => [blockchainKeys.spaceReviews(params.spaceId)]
	});
	const review = useCallback(async function(args, { onSuccess, onError } = {}) {
		const result = await tx.execute(args);
		if (result?.status === TransactionStatus.Success) onSuccess?.();
		else if (result?.status === TransactionStatus.Failed) onError?.(result.error);
		return result;
	}, [tx]);
	return {
		...tx,
		review
	};
}

//#endregion
//#region src/hooks/use-redelegate-stake-transaction.ts
/**
* redelegates an existing stake to a new town
*/
function useRedelegateStakeTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useRedelegateStakeTransaction",
		execute: async ({ depositIds, delegatee, operatorAddress, signer }) => {
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.RedelegateStake,
				debugName: "redelegateStakeTransaction",
				contextData: {
					depositIds,
					delegatee,
					operatorAddress
				},
				aaExecute: () => {
					if (!baseTransactor.userOps) throw new Error("userOps is not initialized");
					return baseTransactor.userOps?.sendRedelegateStakeOp({
						depositIds,
						delegatee,
						operatorAddress,
						signer
					});
				},
				eoaExecute: () => {
					throw new Error("redelegate stake with EOA is not supported");
				},
				errorDecoder: (err) => {
					return baseTransactor.getDecodedErrorForRewardsDistributionV2(err) ?? new Error("Unknown RewardsDistributionV2 error");
				}
			});
		},
		waitForTransaction: (context) => {
			return baseTransactor.waitForBlockchainTransaction(context, void 0, 2);
		},
		invalidateQueries: (_, data) => {
			const queries = [blockchainKeys.myStakingDeposits()];
			if (data?.delegatee) queries.push(blockchainKeys.delegationDataBySpace(data.delegatee));
			data?.depositIds.forEach((depositId) => {
				queries.push(blockchainKeys.stakingDepositDetails(depositId));
			});
			return queries;
		}
	});
	const redelegateToTown = useCallback(async function(args, { onSuccess, onError } = {}) {
		const result = await tx.execute(args);
		if (result?.status === TransactionStatus.Success) onSuccess?.();
		else if (result?.status === TransactionStatus.Failed) onError?.(result.error);
		return result;
	}, [tx]);
	return {
		...tx,
		redelegateToTown
	};
}

//#endregion
//#region src/hooks/use-staking-subgraph.ts
const USER_STAKING_DEPOSITS_QUERY = gql`
    query GetUserStakingDeposits($userId: String!) {
        stakerss(where: { owner: $userId }, limit: 1000) {
            totalCount
            items {
                depositId
                amount
            }
        }
    }
`;
const DEPOSIT_DELEGATION_QUERY = gql`
    query GetDepositDelegation($depositIds: [BigInt!]!) {
        stakerss(where: { depositId_in: $depositIds }) {
            totalCount
            items {
                depositId
                delegatee
                owner
                beneficiary
                amount
                createdAt
            }
        }
    }
`;
const ONE_TOWN = parseUnits("1", 18);
const TOP_STAKING_TOWN_DATA_QUERY = gql`
    query GetTownStakingData {
        spaces(
            where: { totalAmountStaked_gt: "${ONE_TOWN}" }
            orderBy: "totalAmountStaked"
            orderDirection: "desc"
            limit: 1000
        ) {
            items {
                id
                totalAmountStaked
            }
        }
    }
`;
const useTotalStakedByUser = (params) => {
	const { userAddress, enabled = true } = params;
	const { subgraphEndpoint } = useBaseReads();
	const { client } = useTownsContext();
	return useQuery(blockchainKeys.stakingReputationByUser(userAddress), async () => {
		if (!subgraphEndpoint || !userAddress || !client) return null;
		try {
			const data = await request(subgraphEndpoint, USER_STAKING_DEPOSITS_QUERY, { userId: userAddress });
			if (!data?.stakerss || data.stakerss.totalCount === 0) return null;
			const deposits = data.stakerss.items;
			const totalStakingAmount = deposits.reduce((sum, deposit) => {
				return sum + BigInt(deposit.amount);
			}, BigInt(0));
			return {
				userAddress,
				totalStaked: totalStakingAmount.toString(),
				depositsCount: deposits.length
			};
		} catch (error) {
			console.error("[useTotalStakedByUser] Error fetching staking data:", error);
			return null;
		}
	}, {
		enabled: enabled && !!userAddress && !!subgraphEndpoint,
		staleTime: 1e3 * 60 * 15,
		refetchOnWindowFocus: false
	});
};
const useRankedTopStakingTowns = (params) => {
	const { enabled = true } = params;
	const { subgraphEndpoint } = useBaseReads();
	return useQuery(blockchainKeys.stakingRankedTopStakingTowns(), async () => {
		if (!subgraphEndpoint) return void 0;
		try {
			const response = await request(subgraphEndpoint, TOP_STAKING_TOWN_DATA_QUERY);
			if (!response?.spaces?.items) return void 0;
			const topTownsStakingData = response.spaces.items.reduce((acc, space, index) => {
				acc[space.id.toLowerCase()] = {
					totalAmountStaked: space.totalAmountStaked,
					rank: index + 1
				};
				return acc;
			}, {});
			return topTownsStakingData;
		} catch (error) {
			console.error("[useRankedTopStakingTowns] Error fetching town staking data:", error);
			throw error;
		}
	}, {
		enabled: enabled && !!subgraphEndpoint,
		staleTime: 1e3 * 60 * 15,
		refetchOnWindowFocus: false
	});
};
const useDepositsDelegation = (params) => {
	const { depositIds, enabled = true } = params;
	const { subgraphEndpoint } = useBaseReads();
	return useQuery(blockchainKeys.depositsDelegation(depositIds.map((id) => id.toString())), async () => {
		if (!subgraphEndpoint || depositIds.length === 0) return null;
		try {
			const data = await request(subgraphEndpoint, DEPOSIT_DELEGATION_QUERY, { depositIds });
			if (!data?.stakerss || data.stakerss.totalCount === 0) return new Map();
			const delegationMap = new Map();
			data.stakerss.items.forEach((item) => {
				delegationMap.set(item.depositId, item.delegatee);
			});
			return delegationMap;
		} catch (error) {
			console.error("[useDepositsDelegation] Error fetching delegation data:", error instanceof Error ? error.message : "Unknown error");
			return new Map();
		}
	}, {
		enabled: enabled && !!subgraphEndpoint && depositIds.length > 0,
		staleTime: 1e3 * 60 * 15,
		refetchOnWindowFocus: false
	});
};

//#endregion
//#region src/hooks/use-mint-membership-transaction.ts
function useMintMembershipTransaction() {
	const { clientSingleton } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	const { getLinkedWalletsWithDelegations } = useBaseReads();
	return useCallback(async (params) => {
		if (!clientSingleton) throw new Error("clientSingleton is undefined");
		const { signer, spaceId, onJoinFlowStatus, walletType } = params;
		const userId = await signer.getAddress();
		const wallets = await getLinkedWalletsWithDelegations(userId);
		return baseTransactor.mintMembershipTransaction({
			spaceId,
			signer,
			walletType,
			wallets,
			onJoinFlowStatus
		});
	}, [
		clientSingleton,
		baseTransactor,
		getLinkedWalletsWithDelegations
	]);
}

//#endregion
//#region src/hooks/use-mint-then-join.ts
function useMintThenJoin() {
	const { clientSingleton } = useTownsClient();
	const mintMembershipTransaction = useMintMembershipTransaction();
	return useCallback(async (params) => {
		const { spaceId, signer, signerContext, walletType, onJoinFlowStatus, defaultUsername } = params;
		if (!clientSingleton) throw new Error("clientSingleton is undefined");
		if (!signerContext) throw new Error("signerContext is undefined");
		try {
			console.log("[useMintThenJoin] minting membership");
			onJoinFlowStatus?.(JoinFlowStatus.MintingMembership);
			await mintMembershipTransaction({
				spaceId,
				signer,
				walletType,
				onJoinFlowStatus
			});
			console.log("[useMintThenJoin] minted membership");
			onJoinFlowStatus?.(JoinFlowStatus.MembershipMinted);
		} catch (error) {
			if (error && typeof error === "object" && "name" in error && typeof error.name === "string" && error.name.match("MembershipAlreadyMember")) console.log("[useMintThenJoin] membership already minted, joining room");
			else {
				console.error("[useMintThenJoin] mint membership failed", error);
				throw error;
			}
		}
		return clientSingleton.joinRiverSpaceAndDefaultChannels(spaceId, signerContext, onJoinFlowStatus, defaultUsername);
	}, [mintMembershipTransaction, clientSingleton]);
}

//#endregion
//#region src/hooks/use-install-app-transaction.ts
/** Install an app to a space */
function useInstallAppTransaction() {
	const { baseTransactor } = useBaseWrites();
	const qc = useQueryClient();
	const previousInstalledApps = useRef(void 0);
	const tx = useTransaction({
		debugName: "useInstallAppTransaction",
		execute: async ({ appAddress, spaceAddress, price, signer }) => {
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.InstallApp,
				contextData: {
					appAddress,
					spaceAddress,
					price
				},
				debugName: "installAppTransaction",
				aaExecute: () => {
					if (!baseTransactor.userOps) throw new Error("UserOps not found");
					return baseTransactor.userOps.sendInstallAppOp({
						appAddress,
						spaceAddress,
						price,
						signer
					});
				},
				eoaExecute: () => {
					const registry = baseTransactor.appRegistryDapp;
					if (!registry) throw new Error("App registry not found");
					return registry.installApp(signer, appAddress, spaceAddress, price);
				},
				errorDecoder: (error) => {
					return baseTransactor.getDecodedErrorForAppRegistry(error) ?? new Error("Failed to install app");
				}
			});
		},
		invalidateQueries: (params) => [blockchainKeys.accountInstalledApps(params.spaceAddress)],
		optimisticUpdate: {
			apply: (params) => {
				const installedAppsKey = blockchainKeys.accountInstalledApps(params.spaceAddress);
				const currentInstalledApps = qc.getQueryData(installedAppsKey);
				if (currentInstalledApps) {
					previousInstalledApps.current = new Map(currentInstalledApps);
					const updated = new Map(currentInstalledApps);
					updated.set(params.clientAddress, {
						appId: params.appId,
						appAddress: params.appAddress
					});
					qc.setQueryData(installedAppsKey, updated);
				}
			},
			rollback: (params) => {
				if (previousInstalledApps.current !== void 0) qc.setQueryData(blockchainKeys.accountInstalledApps(params.spaceAddress), previousInstalledApps.current);
			}
		}
	});
	const installApp = useCallback(async function(args, { onSuccess, onError } = {}) {
		const result = await tx.execute(args);
		if (result?.status === TransactionStatus.Success) onSuccess?.();
		else if (result?.status === TransactionStatus.Failed) onError?.(result.error);
		return result;
	}, [tx]);
	return {
		...tx,
		installApp
	};
}

//#endregion
//#region src/hooks/use-install-app-on-user-account-transaction.ts
/** Install an app on the user's smart account */
function useInstallAppOnUserAccountTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useInstallAppOnUserAccountTransaction",
		execute: async ({ appAddress, price, signer }) => {
			return baseTransactor.installAppOnUserAccountTransaction({
				appAddress,
				price,
				signer
			});
		},
		invalidateQueries: (params) => [blockchainKeys.accountInstalledApps(params.walletAddress)]
	});
	const installAppOnUserAccount = useCallback(async function(args, { onSuccess, onError } = {}) {
		const result = await tx.execute(args);
		if (result?.status === TransactionStatus.Success) onSuccess?.();
		else if (result?.status === TransactionStatus.Failed) onError?.(result.error);
		return result;
	}, [tx]);
	return {
		...tx,
		installAppOnUserAccount
	};
}

//#endregion
//#region src/hooks/use-install-app-with-module-transaction.ts
/**
* Install AccountModules AND an app on the user's smart account in a single batch transaction.
* Use this when the user doesn't have AccountModules installed yet.
*/
function useInstallAppWithModuleTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useInstallAppWithModuleTransaction",
		execute: async ({ appAddress, price, signer }) => {
			return baseTransactor.installAccountModulesAndAppTransaction({
				appAddress,
				price,
				signer
			});
		},
		invalidateQueries: (params) => [blockchainKeys.accountModulesInstalled(params.walletAddress), blockchainKeys.accountInstalledApps(params.walletAddress)]
	});
	const installAppWithModule = useCallback(async function(args, { onSuccess, onError } = {}) {
		const result = await tx.execute(args);
		if (result?.status === TransactionStatus.Success) onSuccess?.();
		else if (result?.status === TransactionStatus.Failed) onError?.(result.error);
		return result;
	}, [tx]);
	return {
		...tx,
		installAppWithModule
	};
}

//#endregion
//#region src/hooks/use-register-app-transaction.ts
/** Register an app to a client */
function useRegisterAppTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useRegisterAppTransaction",
		execute: async ({ appAddress, clientAddress, signer }) => {
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.RegisterApp,
				contextData: {
					appAddress,
					clientAddress
				},
				debugName: "registerAppTransaction",
				aaExecute: () => {
					return baseTransactor.userOps?.sendRegisterAppOp({
						appAddress,
						clientAddress,
						signer
					});
				},
				eoaExecute: () => {
					const registry = baseTransactor.appRegistryDapp;
					if (!registry) throw new Error("App registry not found");
					return registry.registerApp(signer, appAddress, clientAddress);
				},
				errorDecoder: (error) => {
					return baseTransactor.getDecodedErrorForAppRegistry(error) ?? new Error("Failed to register app");
				}
			});
		}
	});
	return {
		...tx,
		registerApp: tx.execute
	};
}

//#endregion
//#region src/hooks/use-create-app-transaction.ts
/** Create an app */
function useCreateAppTransaction() {
	const { userOpsInstance: userOps, baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		execute: async ({ name, permissions, client, installPrice, accessDuration, signer }) => {
			if (!signer) throw new SignerUndefinedError();
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.CreateApp,
				contextData: {
					name,
					permissions,
					client
				},
				debugName: "createAppTransaction",
				aaExecute: () => {
					if (!userOps) throw new Error("UserOps not initialized");
					return userOps.sendCreateAppOp({
						name,
						permissions,
						client,
						installPrice,
						accessDuration,
						signer
					});
				},
				eoaExecute: () => {
					return baseTransactor.appRegistryDapp.createApp(signer, name, permissions, client, installPrice, accessDuration);
				},
				errorDecoder: (error) => {
					return baseTransactor.getDecodedErrorForAppRegistry(error) ?? new Error("Failed to create app");
				}
			});
		},
		invalidateQueries: () => [blockchainKeys.myBots()],
		debugName: "useCreateAppTransaction"
	});
	return {
		...tx,
		createApp: tx.execute
	};
}

//#endregion
//#region src/hooks/use-give-bot-feedback-transaction.ts
/** Give feedback for a bot */
function useGiveBotFeedbackTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useGiveBotFeedbackTransaction",
		execute: async ({ agentId, score, tag1, tag2, feedbackUri, feedbackHash, signer }) => {
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.GiveBotFeedback,
				contextData: {
					agentId,
					score,
					tag1,
					tag2,
					feedbackUri,
					feedbackHash
				},
				debugName: "giveBotFeedbackTransaction",
				aaExecute: () => {
					if (!baseTransactor.userOps) throw new Error("UserOps not found");
					return baseTransactor.userOps.sendGiveBotFeedbackOp({
						agentId,
						score,
						tag1,
						tag2,
						feedbackUri,
						feedbackHash,
						signer
					});
				},
				eoaExecute: () => {
					const registry = baseTransactor.appRegistryDapp;
					if (!registry) throw new Error("App registry not found");
					const tag1Bytes = tag1 ? ethers.utils.formatBytes32String(tag1) : ethers.constants.HashZero;
					const tag2Bytes = tag2 ? ethers.utils.formatBytes32String(tag2) : ethers.constants.HashZero;
					return registry.reputation.write(signer).giveFeedback(agentId, score, tag1Bytes, tag2Bytes, feedbackUri, feedbackHash);
				},
				errorDecoder: (error) => {
					return baseTransactor.getDecodedErrorForAppRegistry(error) ?? new Error("Failed to give bot feedback");
				}
			});
		}
	});
	const giveBotFeedback = useCallback(async function(args, { onSuccess, onError } = {}) {
		const result = await tx.execute(args);
		if (result?.status === TransactionStatus.Success) onSuccess?.();
		else if (result?.status === TransactionStatus.Failed) onError?.(result.error);
		return result;
	}, [tx]);
	return {
		...tx,
		giveBotFeedback
	};
}

//#endregion
//#region src/hooks/use-agent-feedback-summary.ts
const useAgentFeedbackSummary = (agentId) => {
	const { appRegistryDapp } = useBaseReads();
	return useQuery(blockchainKeys.agentFeedbackSummary(agentId), async () => {
		if (!agentId || !appRegistryDapp) return {
			count: 0,
			averageRating: 0
		};
		try {
			const [count, averageScore] = await appRegistryDapp.reputation.read.getSummary(agentId, [], ethers.constants.HashZero, ethers.constants.HashZero);
			const averageRating = Number(averageScore) / 20;
			return {
				count: Number(count),
				averageRating
			};
		} catch (error) {
			console.error("Error fetching agent feedback summary:", error);
			return {
				count: 0,
				averageRating: 0
			};
		}
	}, {
		enabled: !!agentId && agentId > BigInt(0) && !!appRegistryDapp,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false
	});
};

//#endregion
//#region src/hooks/use-activate-or-install-subscription.ts
/**
* Hook that intelligently handles subscriptions:
* 1. If migrate=true and subscription exists + active, migrates it (pause + activate batch)
* 2. If subscription exists but inactive, activates it
* 3. If subscription doesn't exist, installs a new one
* 4. If subscription exists + active + no migrate, throws error
*/
function useActivateOrInstallSubscription({ onError, onSuccess }) {
	const { userOpsInstance: userOps, baseTransactor } = useBaseWrites();
	const { getSingleSubscription: getSingleSubscription$1 } = useBaseReads();
	return useTransaction({
		execute: async ({ spaceAddress, tokenId, signer, walletAddress, migrate }) => {
			if (!signer) throw new SignerUndefinedError();
			if (!userOps) throw new Error("UserOps not initialized");
			const smartAccount = await userOps.smartAccountSession.getSmartAccount({ signer });
			const spaceDapp = baseTransactor.spaceDapp;
			const existingSubscription = await getSingleSubscription$1({
				walletAddress,
				spaceAddress,
				tokenId
			}).catch(() => null);
			if (existingSubscription && existingSubscription.active && migrate) {
				console.log("[useActivateOrInstallSubscription] Migrating subscription currency", existingSubscription.entityId);
				return baseTransactor.createTransaction({
					signer,
					type: BlockchainTransactionType.MigrateSubscriptionCurrency,
					debugName: "migrateSubscriptionCurrencyTransaction",
					contextData: {
						isActivate: false,
						isMigrate: true,
						myAddress: smartAccount.address
					},
					aaExecute: () => {
						if (!userOps) throw new Error("UserOps not initialized");
						return migrateSubscriptionCurrency({
							entityId: Number(existingSubscription.entityId),
							smartAccount,
							signer,
							spaceDapp
						});
					},
					eoaExecute: () => {
						throw new Error("Not supported for EOA");
					},
					errorDecoder: (error) => {
						return baseTransactor.getDecodedErrorForAppRegistry(error) ?? new Error("Failed to migrate subscription currency");
					}
				});
			}
			if (existingSubscription && !existingSubscription.active) {
				console.log("[useActivateOrInstallSubscription] Subscription exists but is inactive, activating it");
				return baseTransactor.createTransaction({
					signer,
					type: BlockchainTransactionType.ActivateSubscription,
					debugName: "activateSubscriptionTransaction",
					contextData: {
						isActivate: true,
						isMigrate: false,
						myAddress: smartAccount.address
					},
					aaExecute: () => {
						if (!userOps) throw new Error("UserOps not initialized");
						return activateSubscription({
							entityId: Number(existingSubscription.entityId),
							smartAccount,
							signer,
							spaceDapp
						});
					},
					eoaExecute: () => {
						throw new Error("Not supported for EOA");
					},
					errorDecoder: (error) => {
						return baseTransactor.getDecodedErrorForAppRegistry(error) ?? new Error("Failed to activate subscription");
					}
				});
			}
			if (!existingSubscription) {
				console.log("[useActivateOrInstallSubscription] No subscription exists, installing a new one");
				return await baseTransactor.createTransaction({
					signer,
					type: BlockchainTransactionType.InstallSubscription,
					contextData: {
						isActivate: false,
						isMigrate: false,
						myAddress: smartAccount.address
					},
					debugName: "installSubscriptionTransaction",
					aaExecute: () => {
						if (!userOps) throw new Error("UserOps not initialized");
						const smartAccountSessionConfig = userOps.smartAccountSession.getConfig();
						const { paymasterProxyUrl, paymasterProxyAuthSecret } = smartAccountSessionConfig;
						if (!paymasterProxyUrl) throw new Error("Paymaster proxy URL not initialized");
						if (!paymasterProxyAuthSecret) throw new Error("Paymaster proxy auth secret not initialized");
						return installSubscription({
							spaceAddress,
							tokenId,
							smartAccount,
							signer,
							paymasterProxyUrl,
							paymasterProxyAuthSecret
						});
					},
					eoaExecute: () => {
						throw new Error("Not supported for EOA");
					},
					errorDecoder: (error) => {
						return baseTransactor.getDecodedErrorForAppRegistry(error) ?? new Error("Failed to install subscription");
					}
				});
			}
			throw new Error("Subscription is already active");
		},
		onSuccess: ({ spaceAddress, tokenId }, context) => {
			onSuccess?.({
				spaceAddress,
				tokenId,
				myAddress: context.data?.myAddress,
				isActivate: !!context.data?.isActivate,
				isMigrate: !!context.data?.isMigrate
			});
		},
		onError: (error, { spaceAddress, tokenId }, context) => {
			onError?.({
				spaceAddress,
				tokenId,
				error,
				isActivate: !!context.data?.isActivate,
				isMigrate: !!context.data?.isMigrate
			});
		},
		debugName: "useActivateOrInstallSubscription"
	});
}
/**
* Hook to pause an active subscription
*/
function usePauseSubscription({ onError, onSuccess }) {
	const { userOpsInstance: userOps, baseTransactor } = useBaseWrites();
	return useTransaction({
		execute: async ({ entityId, signer }) => {
			if (!signer) throw new SignerUndefinedError();
			if (!userOps) throw new Error("UserOps not initialized");
			console.log("[usePauseSubscription] Pausing subscription", entityId);
			const smartAccount = await userOps.smartAccountSession.getSmartAccount({ signer });
			const spaceDapp = baseTransactor.spaceDapp;
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.PauseSubscription,
				debugName: "pauseSubscriptionTransaction",
				aaExecute: () => {
					if (!userOps) throw new Error("UserOps not initialized");
					return pauseSubscription({
						entityId,
						smartAccount,
						signer,
						spaceDapp
					});
				},
				eoaExecute: () => {
					throw new Error("Not supported for EOA");
				},
				errorDecoder: (error) => {
					return baseTransactor.getDecodedErrorForAppRegistry(error) ?? new Error("Failed to pause subscription");
				}
			});
		},
		onSuccess: ({ entityId }) => {
			onSuccess?.({ entityId });
		},
		onError: (error, { entityId }) => {
			onError?.({
				entityId,
				error
			});
		},
		debugName: "usePauseSubscription"
	});
}

//#endregion
//#region src/store/use-transactions-store.ts
const useTransactionStore = () => {
	const [transactions, setTransactions] = useState({});
	const { baseTransactor } = useBaseWrites();
	useEffect(() => {
		const handleChange = (transactions$1) => {
			setTransactions((s) => ({
				...s,
				...transactions$1
			}));
		};
		baseTransactor.blockchainTransactionStore.on("transactions", handleChange);
		return () => {
			baseTransactor.blockchainTransactionStore.off("transactions", handleChange);
		};
	}, [baseTransactor]);
	return transactions;
};
const useOnTransactionUpdated = (callback, cleanup) => {
	const { baseTransactor } = useBaseWrites();
	const cbRef = useRef(callback);
	cbRef.current = callback;
	const cleanupRef = useRef(cleanup);
	cleanupRef.current = cleanup;
	useEffect(() => {
		const cb = (args) => cbRef.current(args);
		baseTransactor.blockchainTransactionStore.on("updatedTransaction", cb);
		return () => {
			baseTransactor.blockchainTransactionStore.off("updatedTransaction", cb);
			cleanupRef.current?.();
		};
	}, [baseTransactor]);
};
const useIsTransactionPending = (...type) => {
	const transactions = useTransactionStore();
	return useMemo(() => Object.values(transactions).some((tx) => type.includes(tx.type) && (tx.status === "pending" || tx.status === "potential")), [transactions, type]);
};

//#endregion
//#region src/hooks/use-renew-membership.ts
function useRenewMembership() {
	const { baseTransactor } = useBaseWrites();
	const { isEntitled } = useBaseReads();
	const result = useTransaction({
		debugName: "useRenewMembership",
		execute: async ({ spaceId, tokenId, signer, subscriptionConfig }) => {
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.RenewMembership,
				debugName: "useRenewMembership",
				contextData: {
					spaceId,
					tokenId
				},
				aaExecute: async () => {
					if (!baseTransactor.userOps) throw new Error("UserOps is not initialized");
					return baseTransactor.userOps?.renewMembership({
						spaceId,
						tokenId,
						signer,
						subscriptionConfig
					});
				},
				eoaExecute: async () => {
					const space = baseTransactor.spaceDapp.getSpace(spaceId);
					if (!space) throw new Error(`Space with spaceId "${spaceId}" is not found.`);
					return space.Membership.renewMembership({
						tokenId,
						signer
					});
				},
				errorDecoder: (error) => baseTransactor.getDecodedErrorForSpace(spaceId, error)
			});
		},
		onSuccess: async (params) => {
			await bustMembershipStatus({
				userId: params.userId,
				spaceId: params.spaceId
			});
			await invalidateHasPermissionQueriesForSpace({
				spaceId: params.spaceId,
				predicate: (data) => data === false,
				isEntitled
			});
		}
	});
	const renewMembershipMethod = useCallback(async function(args) {
		const { onSuccess, onError,...params } = args;
		return result.execute(params).then((context) => {
			if (context?.status === TransactionStatus.Success) onSuccess?.();
			else if (context?.status === TransactionStatus.Failed) onError?.(context.error || new Error("Transaction failed"));
			return context;
		}, (error) => {
			onError?.(error);
			throw error;
		});
	}, [result]);
	return {
		...result,
		renewMembership: renewMembershipMethod
	};
}

//#endregion
//#region src/hooks/use-claim-reward-transaction.ts
function useClaimRewardTransaction() {
	const { userOpsInstance: userOps, baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		debugName: "useClaimRewardTransaction",
		execute: async ({ beneficiary, recipient, signer }) => {
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.ClaimReward,
				debugName: "useClaimRewardTransaction",
				contextData: {
					beneficiary,
					recipient
				},
				aaExecute: async () => {
					if (!userOps) throw new Error("UserOps is not initialized");
					return userOps.claimReward({
						beneficiary,
						recipient,
						signer
					});
				},
				eoaExecute: async () => {
					if (!baseTransactor.spaceDapp.baseRegistry.rewardsDistributionV2) throw new Error("Rewards distribution is not initialized");
					return baseTransactor.spaceDapp.baseRegistry.rewardsDistributionV2.write(signer).claimReward(beneficiary, recipient);
				},
				errorDecoder: (error) => baseTransactor.getDecodedErrorForRewardsDistributionV2(error) ?? error
			});
		},
		invalidateQueries: () => [
			blockchainKeys.myStakingDeposits(),
			blockchainKeys.myStakingRewards(),
			blockchainKeys.townsTokenBalance()
		]
	});
	const claimRewardMethod = useCallback(async function(args) {
		const { onSuccess, onError,...params } = args;
		const result = await tx.execute(params);
		if (result?.status === TransactionStatus.Success) onSuccess?.();
		else if (result?.status === TransactionStatus.Failed) onError?.(result.error);
		return result;
	}, [tx]);
	return {
		...tx,
		claimReward: claimRewardMethod
	};
}

//#endregion
//#region src/types/room-identifier.ts
function toRoomIdentifier(slugOrId) {
	if (!slugOrId) return void 0;
	if (!isValidStreamId(slugOrId)) return void 0;
	return slugOrId;
}

//#endregion
//#region src/hooks/use-refresh-metadata.ts
function useRefreshMetadataTx() {
	const { baseTransactor } = useBaseWrites();
	const result = useTransaction({
		debugName: "useRefreshMetadataTransaction",
		execute: async ({ spaceId, signer }) => {
			return baseTransactor.createTransaction({
				debugName: "refreshMetadataTransaction",
				type: BlockchainTransactionType.RefreshMetadata,
				signer,
				aaExecute: async () => {
					if (!baseTransactor.userOps) throw new Error("userOps not found");
					return baseTransactor.userOps?.refreshMetadata([spaceId, signer]);
				},
				eoaExecute: async () => {
					return baseTransactor.spaceDapp.refreshMetadata(spaceId, signer);
				},
				errorDecoder: (error) => new Error(error)
			});
		}
	});
	return {
		...result,
		refreshMetadataTransaction: result.execute
	};
}

//#endregion
//#region src/hooks/use-river-points.ts
const SECONDS_MS = 1e3;
const HOUR_MS$1 = 60 * 60 * SECONDS_MS;
const DAY_MS = 24 * HOUR_MS$1;
const GRACE_PERIOD_MS = 48 * HOUR_MS$1;
function useRiverPoints(loggedInWalletAddress) {
	const { baseChain: chain, clientStatus } = useTownsContext();
	const { spaceIds } = useSpacesIds();
	const { spaceDapp } = useTownsClient();
	const previousSpaceIdsRef = useRef([]);
	const isLocalDataLoaded = clientStatus.isLocalDataLoaded;
	useEffect(() => {
		if (!isLocalDataLoaded) return;
		const hasSpaceIds = spaceIds && spaceIds.length > 0;
		const previousSpaceIds = previousSpaceIdsRef.current;
		const spaceIdsChanged = JSON.stringify(spaceIds) !== JSON.stringify(previousSpaceIds);
		if (!hasSpaceIds || !spaceIdsChanged) return;
		previousSpaceIdsRef.current = spaceIds;
		console.debug("[river-points] invalidate points due to meaningful spaceIds change", {
			previous: previousSpaceIds,
			current: spaceIds
		});
		queryClient.invalidateQueries({ queryKey: blockchainKeys.riverPoints(loggedInWalletAddress ?? "") });
	}, [
		chain.id,
		loggedInWalletAddress,
		spaceIds,
		isLocalDataLoaded
	]);
	const dapp = spaceDapp?.airdrop;
	if (!dapp) throw new Error("RiverPoints is not deployed");
	const { data, isLoading, isError, error } = useRiverPointsDetails(loggedInWalletAddress);
	const [now, setNow] = useState(() => Date.now());
	const lastCheckIn = data?.lastCheckIn;
	useEffect(() => {
		const interval = setInterval(() => {
			setNow(Date.now());
		}, 60 * SECONDS_MS);
		const nextCheckIn = lastCheckIn ? lastCheckIn + DAY_MS - Date.now() : 0;
		const nextStreakReset = lastCheckIn ? lastCheckIn + GRACE_PERIOD_MS - Date.now() : 0;
		const timeouts = [];
		if (nextCheckIn > 0) timeouts.push(setTimeout(() => {
			setNow(Date.now());
		}, nextCheckIn));
		if (nextStreakReset > 0) timeouts.push(setTimeout(() => {
			setNow(Date.now());
		}, nextStreakReset));
		return () => {
			clearInterval(interval);
			timeouts.forEach(clearTimeout);
		};
	}, [lastCheckIn]);
	const isActive = !lastCheckIn || lastCheckIn < now - DAY_MS;
	const shouldResetStreak = lastCheckIn && lastCheckIn < now - GRACE_PERIOD_MS;
	const displayStreak = shouldResetStreak ? 0 : data?.currentStreak ?? 0;
	useEffect(() => {
		if (isError) console.error("[river-points] error", error);
	}, [isError, error]);
	const debugPointsRef = useRef(false);
	useEffect(() => {
		if (data && debugPointsRef.current) {
			console.debug("[river-points] data", data);
			console.debug("[river-points] isActive calculation:", {
				lastCheckIn: data.lastCheckIn,
				now,
				dayMs: DAY_MS,
				nowMinusDay: now - DAY_MS,
				isActive,
				calculation: `!${data.lastCheckIn} || ${data.lastCheckIn} < ${now - DAY_MS}`,
				lastCheckInDate: data.lastCheckIn ? new Date(data.lastCheckIn).toISOString() : "null",
				nowDate: new Date(now).toISOString(),
				timeSinceLastCheckIn: data.lastCheckIn ? now - data.lastCheckIn : "N/A"
			});
			console.debug("[river-points] streak calculation:", {
				contractStreak: data.currentStreak,
				shouldResetStreak,
				displayStreak,
				gracePeriodMs: GRACE_PERIOD_MS,
				timeSinceLastCheckIn: data.lastCheckIn ? now - data.lastCheckIn : "N/A",
				gracePeriodExpired: data.lastCheckIn ? data.lastCheckIn < now - GRACE_PERIOD_MS : false
			});
		}
	}, [
		data,
		isActive,
		now,
		shouldResetStreak,
		displayStreak
	]);
	return useMemo(() => {
		return {
			data: data ? {
				...data,
				isActive,
				currentStreak: displayStreak
			} : void 0,
			isLoading,
			isError
		};
	}, [
		data,
		isLoading,
		isError,
		isActive,
		displayStreak
	]);
}
function useRiverPointsCheckIn(loggedInWalletAddress, options = {}) {
	const queryClient$1 = useQueryClient();
	const { onSuccess, onError, onPotential, onPending } = options;
	useOnTransactionUpdated((tx) => {
		if (tx.type === BlockchainTransactionType.CheckIn) switch (tx.status) {
			case "success":
				queryClient$1.invalidateQueries({ queryKey: blockchainKeys.riverPoints(loggedInWalletAddress ?? "") });
				onSuccess?.();
				break;
			case "failure":
				onError?.(tx.error);
				break;
			case "potential":
				onPotential?.();
				break;
			case "pending":
				onPending?.();
				break;
		}
	});
	const { checkIn, isLoading } = useCheckInTransaction();
	return {
		checkIn,
		isLoading
	};
}

//#endregion
//#region src/client/SignMessageAbortController.ts
/**
* AbortController that can be used to abort signMessage requests during login
*/
let signMessageAbortController = new AbortController();
/**
* @returns A promise that rejects when the signMessageAbortController is aborted
* When the promise rejects, the signMessageAbortController is reset so the signal can be used again
*/
const signMessageAbortListener = () => new Promise((_, reject) => {
	signMessageAbortController.signal.addEventListener("abort", () => {
		signMessageAbortController = new AbortController();
		reject(new DOMException("Aborted", "AbortError"));
	}, { once: true });
});

//#endregion
//#region src/utils/erc20-utils.ts
function generateApproveAmountCallData(spender, amount) {
	const erc20Interface = new ethers.utils.Interface(erc20Abi);
	return erc20Interface.encodeFunctionData("approve", [spender, amount]);
}
/**
* Extracts the transfer amount from transaction logs for a specific ERC20 token transfer.
*
* This function is needed because when processing ERC20 token transfers in transactions,
* we need to extract the final transfer amount from the transaction logs.
* Before submitting a transaction, we don't know what the exact amount will be
* (especially in cases with fees or slippage), so we need to parse the logs
* after the transaction is complete to determine the actual amount transferred.

* @param logs - Array of transaction logs to search through
* @param walletAddress - Address of the wallet involved in the transfer
* @param tokenAddress - Address of the ERC20 token being transferred
* @returns The amount transferred as a bigint, or 0 if no matching transfer was found
*/
function extractTransferAmountFromLogs(logs, walletAddress, tokenAddress) {
	const erc20Interface = new ethers.utils.Interface(erc20Abi);
	let largestAmount = 0n;
	for (const log of logs) if (log.address.toLowerCase() === tokenAddress.toLowerCase()) try {
		const parsedLog = erc20Interface.parseLog(log);
		if (parsedLog.name === "Transfer" && parsedLog.args && (parsedLog.args.from.toLowerCase() === walletAddress.toLowerCase() || parsedLog.args.to.toLowerCase() === walletAddress.toLowerCase())) {
			const amount = BigInt(parsedLog.args.value.toString());
			if (amount > largestAmount) largestAmount = amount;
		}
	} catch (error) {
		continue;
	}
	return largestAmount;
}

//#endregion
//#region src/utils/swapUtils.ts
async function calculateMinAmountBase(params) {
	if (!params.simulateSwapOutput) throw new Error("simulateSwapOutput is required");
	const exactInputParams = {
		tokenIn: params.tokenIn,
		tokenOut: params.tokenOut,
		amountIn: params.amountIn,
		minAmountOut: 0n,
		recipient: params.walletAddress
	};
	const routerParams = {
		router: params.router,
		approveTarget: params.approveTarget,
		swapData: params.swapData
	};
	const needsApproval = params.tokenIn !== ETH_ADDRESS;
	const swapContractAddress = params.spaceId !== void 0 ? SpaceAddressFromSpaceId(params.spaceId) : params.swapRouterAddress;
	const approval = needsApproval ? {
		callData: generateApproveAmountCallData(swapContractAddress, params.amountIn),
		toAddress: params.tokenIn
	} : void 0;
	const toAmount = await params.simulateSwapOutput({
		...params,
		exactInputParams,
		routerParams,
		value: params.tokenIn === ETH_ADDRESS ? BigInt(params.amountIn) : 0n,
		approval
	});
	const slippageBps = BigInt(Math.round(params.slippage * 1e4));
	const toAmountMin = toAmount * (10000n - slippageBps) / 10000n;
	return {
		toAmount: toAmount.toString(),
		toAmountMin: toAmountMin.toString()
	};
}
async function getETHInputAmountAfterFees({ amountIn, caller, poster, swapRouterAddress, publicClient }) {
	const data = ISwapRouter__factory.createInterface().encodeFunctionData("getETHInputFees", [
		amountIn,
		caller,
		poster
	]);
	const result = await publicClient.request({
		method: "eth_call",
		params: [{
			data,
			to: swapRouterAddress
		}, "latest"]
	});
	if (!result || !result.startsWith("0x")) throw new Error("Failed to parse getETHInputFees result");
	const [amountInAfterFees, protocolFee, posterFee] = decodeAbiParameters([
		{ type: "uint256" },
		{ type: "uint256" },
		{ type: "uint256" }
	], result);
	return {
		amountInAfterFees: amountInAfterFees.toString(),
		protocolFee: protocolFee.toString(),
		posterFee: posterFee.toString()
	};
}

//#endregion
//#region src/utils/miniapp.ts
const MINIAPP_COMMAND_PREFIX = "MINIAPP";
const MiniappActionSchema = z.object({
	type: z.enum([
		"launch_frame",
		"view_token",
		"launch_miniapp",
		"open_url"
	]),
	name: z.string().min(1).max(128).optional(),
	url: z.string().max(1024).url().optional(),
	splashImageUrl: z.string().max(1024).url().optional(),
	splashBackgroundColor: z.string().optional()
});
const MiniappEmbedSchema = z.object({
	version: z.union([z.literal("1"), z.literal("next")]),
	imageUrl: z.string().max(1024).url(),
	button: z.object({
		title: z.string().min(1).max(32),
		action: MiniappActionSchema
	}).strict()
});
const MINIAPP_COMMAND_REGEX = new RegExp(`^${MINIAPP_COMMAND_PREFIX}\\s+(https?://\\S+)$`, "i");
/**
* Parses `MINIAPP <url>` commands embedded in message bodies.
* Returns the normalized URL when present, otherwise null.
*/
const parseMiniappCommand = (body) => {
	if (!body) return null;
	const trimmedBody = body.trim();
	const match = trimmedBody.match(MINIAPP_COMMAND_REGEX);
	if (!match) return null;
	const url = match[1];
	try {
		const normalized = new URL(url);
		if (normalized.protocol !== "http:" && normalized.protocol !== "https:") return null;
		return { url: normalized.toString() };
	} catch {
		return null;
	}
};
const isMiniappCommand = (body) => {
	return parseMiniappCommand(body) !== null;
};

//#endregion
//#region src/types/notification-types.ts
const AT_CHANNEL_MENTION = "@channel";
const AT_CHANNEL_MENTION_DISPLAY = "channel";

//#endregion
//#region src/hooks/use-claim-and-stake-to-town-transaction.ts
function useClaimAndStakeToTownTransaction({ onSuccess, onError, onPending }) {
	const { userOpsInstance: userOps, baseTransactor } = useBaseWrites();
	return useTransaction({
		debugName: "useClaimAndStakeToTownTransaction",
		execute: ({ amount, delegatee, beneficiary, operatorAddress, signer }) => {
			if (!signer) throw new Error("signer is not initialized");
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.ClaimRewardAndStakeToTowns,
				debugName: "claimRewardAndStakeToTownTransaction",
				contextData: {
					amount,
					delegatee,
					beneficiary,
					operatorAddress
				},
				aaExecute: () => {
					if (!userOps) throw new Error("userOps is not initialized");
					return userOps.sendClaimRewardAndStakeToTownOp({
						amount,
						delegatee,
						beneficiary,
						operatorAddress,
						signer
					});
				},
				eoaExecute: () => {
					throw new Error("claimRewardAndStakeToTownTransaction with EOA is not supported");
				},
				errorDecoder: (err) => {
					let error = baseTransactor.getDecodedErrorForRewardsDistributionV2(err);
					if (!error || error.name === "UNKNOWN_ERROR") error = baseTransactor.parseSpaceDelegationError({
						message: "Failed to claim and stake to town",
						originalError: err
					});
					return error;
				}
			});
		},
		waitForTransaction: (context) => {
			return baseTransactor.waitForBlockchainTransaction(context, void 0, 2);
		},
		invalidateQueries: (params) => {
			const queries = [
				blockchainKeys.townsTokenBalance(),
				blockchainKeys.myStakingRewards(),
				blockchainKeys.myStakingDeposits(),
				blockchainKeys.delegationDataBySpace(params.delegatee),
				blockchainKeys.stakingReputationByUser()
			];
			if (params.operatorAddress) queries.push(blockchainKeys.delegationDataByOperator(params.operatorAddress));
			return queries;
		},
		onSuccess,
		onError,
		onPending
	});
}

//#endregion
//#region src/hooks/use-claim-and-increase-stake-to-town-transaction.ts
function useClaimAndIncreaseStakeToTownTransaction({ onSuccess, onError, onPending }) {
	const { clientSingleton } = useTownsClient();
	const { userOpsInstance: userOps, baseTransactor } = useBaseWrites();
	return useTransaction({
		debugName: "useClaimAndIncreaseStakeToTownTransaction",
		execute: ({ amount, delegatee, beneficiary, depositId, signer }) => {
			if (!signer) throw new Error("signer is not initialized");
			if (!clientSingleton) throw new Error("clientSingleton is not initialized");
			return baseTransactor.createTransaction({
				signer,
				type: BlockchainTransactionType.ClaimRewardAndIncreaseStakeToTowns,
				debugName: "claimRewardAndIncreaseStakeToTownTransaction",
				contextData: {
					amount,
					delegatee,
					depositId,
					beneficiary
				},
				aaExecute: () => {
					if (!userOps) throw new Error("userOps is not initialized");
					return userOps.sendClaimRewardAndIncreaseStakeToTownOp({
						amount,
						delegatee,
						depositId,
						beneficiary,
						signer
					});
				},
				eoaExecute: () => {
					throw new Error("claimRewardAndIncreaseStakeToTownTransaction with EOA is not supported");
				},
				errorDecoder: (err) => {
					let error = baseTransactor.getDecodedErrorForRewardsDistributionV2(err);
					if (!error || error.name === "UNKNOWN_ERROR") error = baseTransactor.parseSpaceDelegationError({
						message: "Failed to claim and increase stake to town",
						originalError: err
					});
					return error;
				}
			});
		},
		waitForTransaction: (context) => {
			if (!clientSingleton) throw new Error("clientSingleton is not initialized");
			return baseTransactor.waitForBlockchainTransaction(context, void 0, 2);
		},
		invalidateQueries: (params) => {
			const queries = [
				blockchainKeys.townsTokenBalance(),
				blockchainKeys.myStakingRewards(),
				blockchainKeys.myStakingDeposits(),
				blockchainKeys.delegationDataBySpace(params.delegatee),
				blockchainKeys.stakingReputationByUser()
			];
			return queries;
		},
		onSuccess,
		onError,
		onPending
	});
}

//#endregion
//#region src/hooks/use-bot-channels.ts
const DEFAULT_OBSERVABLE = new Observable({});
const EMPTY_BOT_CHANNELS = [];
function useBotChannels(channelIds, botClientAddress) {
	const { casablancaClient } = useTownsContext();
	const observable = casablancaClient?.streamsView.streamMemberIds ?? DEFAULT_OBSERVABLE;
	return useObservableWith(observable, useCallback((streamMemberIds) => {
		if (!botClientAddress || channelIds.length === 0) return EMPTY_BOT_CHANNELS;
		return channelIds.filter((channelId) => streamMemberIds[channelId]?.includes(botClientAddress));
	}, [channelIds, botClientAddress]));
}

//#endregion
//#region src/hooks/use-bot-status.ts
const zJavascriptBotVersion = z.string().regex(/^javascript:@towns-protocol\/bot:\d+\.\d+\.\d+$/).optional().transform((v) => v);
const createBotStatusQueryOptions = (appClientAddress, townsEnv, environmentId) => {
	return queryOptions$1({
		queryKey: blockchainKeys.botStatus(appClientAddress),
		queryFn: async () => {
			if (!appClientAddress) return {
				isRegistered: false,
				validResponse: false,
				isActive: false,
				version: void 0
			};
			try {
				const appRegistryRpcClient = makeAppRegistryRpcClient(townsEnv.getAppRegistryUrl(environmentId), "");
				const statusResponse = await appRegistryRpcClient.getStatus({ appId: bin_fromHexString(appClientAddress) });
				return {
					isRegistered: statusResponse.isRegistered,
					validResponse: statusResponse.validResponse,
					isActive: statusResponse.active,
					version: zJavascriptBotVersion.safeParse(statusResponse.status?.clientVersion).data
				};
			} catch (error) {
				console.error("Error fetching bot status:", error);
				return {
					isRegistered: false,
					validResponse: false,
					isActive: false,
					version: void 0
				};
			}
		},
		staleTime: defaultStaleTime,
		enabled: !!appClientAddress,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false
	});
};
const useBotStatus = (appClientAddress) => {
	const { environmentId, townsEnv } = useTownsContext();
	return useQuery$1(createBotStatusQueryOptions(appClientAddress, townsEnv, environmentId));
};
const useBotStatusPrefetch = () => {
	const queryClient$1 = useQueryClient$1();
	const { environmentId, townsEnv } = useTownsContext();
	return useCallback(async (appClientAddress) => {
		if (!appClientAddress) return;
		await queryClient$1.prefetchQuery(createBotStatusQueryOptions(appClientAddress, townsEnv, environmentId));
	}, [
		queryClient$1,
		environmentId,
		townsEnv
	]);
};
const useBotStatusArray = (clientAddresses) => {
	const { environmentId, townsEnv } = useTownsContext();
	return useQueries$1({
		queries: clientAddresses.map((clientAddress) => ({
			...createBotStatusQueryOptions(clientAddress, townsEnv, environmentId),
			refetchOnWindowFocus: false,
			refetchOnMount: false
		})),
		combine: (results) => ({
			data: results.map((r) => r.data),
			isLoading: results.some((r) => r.isLoading)
		})
	});
};

//#endregion
//#region src/hooks/use-bot-installed-in.ts
const GET_BOT_INSTALLED_IN_QUERY = gql`
    query GetAppsByAppId($address: String!) {
        apps(where: { address: $address }) {
            items {
                installedIn
            }
        }
    }
`;
const useBotInstalledIn = (appAddress) => {
	const { subgraphEndpoint } = useBaseReads();
	return useQuery(blockchainKeys.botInstalledInAccounts(appAddress), async () => {
		if (!subgraphEndpoint) return [];
		const response = await request(subgraphEndpoint, GET_BOT_INSTALLED_IN_QUERY, { address: appAddress });
		return response?.apps?.items?.[0]?.installedIn;
	}, { enabled: !!subgraphEndpoint });
};

//#endregion
//#region src/hooks/use-agent-promotion-status.ts
const createAgentPromotionStatusQueryOptions = (appAddress, appRegistryDapp) => {
	return queryOptions$1({
		queryKey: blockchainKeys.agentPromotionStatus(appAddress),
		queryFn: async () => {
			if (!appAddress || !appRegistryDapp) return {
				isPromoted: false,
				agentId: BigInt(0)
			};
			try {
				const simpleApp = appRegistryDapp.callApp(appAddress);
				const agentId = await simpleApp.read.getAgentId();
				return {
					isPromoted: agentId.toBigInt() > BigInt(0),
					agentId
				};
			} catch (error) {
				console.error("Error fetching agent promotion status:", error);
				return {
					isPromoted: false,
					agentId: BigInt(0)
				};
			}
		},
		enabled: !!appAddress && !!appRegistryDapp,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false
	});
};
const useAgentPromotionStatus = (appAddress) => {
	const { appRegistryDapp } = useBaseReads();
	return useQuery$1({
		queryKey: blockchainKeys.agentPromotionStatus(appAddress),
		queryFn: async () => {
			if (!appAddress || !appRegistryDapp) return {
				isPromoted: false,
				agentId: BigInt(0)
			};
			try {
				const simpleApp = appRegistryDapp.callApp(appAddress);
				const agentId = await simpleApp.read.getAgentId();
				return {
					isPromoted: agentId.toBigInt() > BigInt(0),
					agentId: agentId.toBigInt()
				};
			} catch (error) {
				console.error("Error fetching agent promotion status:", error);
				return {
					isPromoted: false,
					agentId: BigInt(0)
				};
			}
		},
		enabled: !!appAddress && !!appRegistryDapp,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false
	});
};

//#endregion
//#region src/hooks/use-promote-agent-transaction.ts
/** Promote an agent on-chain */
function usePromoteAgentTransaction() {
	const { baseTransactor } = useBaseWrites();
	const tx = useTransaction({
		execute: async ({ appAddress, agentUri, signer }) => {
			if (!signer) throw new SignerUndefinedError();
			const params = {
				appAddress,
				agentUri,
				signer
			};
			return baseTransactor.promoteAgent(params);
		},
		invalidateQueries: (params) => [
			blockchainKeys.botData(params.appAddress),
			blockchainKeys.agentPromotionStatus(params.appAddress),
			blockchainKeys.myBots()
		],
		debugName: "usePromoteAgentTransaction"
	});
	return {
		...tx,
		promoteAgent: tx.execute
	};
}

//#endregion
//#region src/hooks/use-apps-in-channel.ts
const useAppsInChannel = (spaceId, channelId) => {
	const { data: installedApps, isLoading } = useInstalledApps(spaceId ? SpaceAddressFromSpaceId(spaceId) : void 0);
	const { memberIds: channelMemberIds } = useMemberIds(channelId);
	const apps = useMemo(() => {
		const channelMemberIdsLower = channelMemberIds.map((id) => id.toLowerCase());
		return Array.from(installedApps?.entries() ?? []).filter(([appClientAddress]) => channelMemberIdsLower.includes(appClientAddress.toLowerCase())).map(([appClientAddress, { appId, appAddress }]) => ({
			appId,
			appAddress,
			appClientAddress
		}));
	}, [installedApps, channelMemberIds]);
	return {
		apps,
		isLoading
	};
};

//#endregion
//#region src/hooks/use-channel-slash-commands.ts
const useChannelSlashCommands = (spaceId, channelId, { enabled } = {}) => {
	const { appRegistryDapp } = useBaseReads();
	const { environmentId, townsEnv } = useTownsContext();
	const { apps: appsInChannel, isLoading: isLoadingApps } = useAppsInChannel(spaceId, channelId);
	const botDataQueries = useMemo(() => {
		if (!appsInChannel || appsInChannel.length === 0) return [];
		return appsInChannel.map(({ appAddress }) => queryOptions({
			...createBotDataQueryOptions(appAddress, townsEnv, appRegistryDapp, environmentId),
			enabled
		}));
	}, [
		appsInChannel,
		townsEnv,
		appRegistryDapp,
		environmentId,
		enabled
	]);
	const botStatusQueries = useMemo(() => {
		if (!appsInChannel || appsInChannel.length === 0) return [];
		return appsInChannel.map(({ appClientAddress }) => queryOptions({
			...createBotStatusQueryOptions(appClientAddress, townsEnv, environmentId),
			enabled
		}));
	}, [
		appsInChannel,
		townsEnv,
		environmentId,
		enabled
	]);
	const botDataResults = useQueries({
		queries: botDataQueries,
		combine: (results) => ({
			data: results.map((r) => r.data),
			isLoadingByIndex: results.map((r) => r.isLoading),
			isLoadingAny: results.some((r) => r.isLoading),
			isErrorAny: results.some((r) => r.isError)
		})
	});
	const botStatusResults = useQueries({
		queries: botStatusQueries,
		combine: (results) => ({
			data: results.map((r) => r.data),
			isLoadingByIndex: results.map((r) => r.isLoading),
			isLoadingAny: results.some((r) => r.isLoading),
			isErrorAny: results.some((r) => r.isError)
		})
	});
	return useMemo(() => {
		if (!appsInChannel || appsInChannel.length === 0) return {
			data: [],
			isLoading: false,
			isError: false
		};
		const statusMap = new Map();
		appsInChannel.forEach(({ appClientAddress }, index) => {
			const status = botStatusResults.data[index];
			if (status && appClientAddress) statusMap.set(appClientAddress, status);
		});
		const data = appsInChannel.map(({ appAddress, appClientAddress }, index) => {
			const botData = botDataResults.data[index];
			if (!botData) return null;
			const slashCommands = botData.metadata?.slashCommands ?? [];
			if (slashCommands.length === 0) return null;
			const status = statusMap.get(appClientAddress);
			const isStatusLoading = botStatusResults.isLoadingByIndex[index];
			if (!isStatusLoading && status?.isActive === false) return null;
			return {
				appAddress,
				appClientAddress,
				slashCommands,
				botName: botData?.metadata?.displayName
			};
		}).filter((d) => d !== null);
		const isLoading = botDataResults.isLoadingAny;
		const isError = botDataResults.isErrorAny || botStatusResults.isErrorAny;
		return {
			data,
			isLoading: isLoadingApps || isLoading,
			isError
		};
	}, [
		appsInChannel,
		botDataResults,
		botStatusResults,
		isLoadingApps
	]);
};

//#endregion
//#region src/hooks/use-dm-slash-commands.ts
const useDMSlashCommands = (streamId, { enabled = true } = {}) => {
	const { appRegistryDapp } = useBaseReads();
	const { environmentId, townsEnv } = useTownsContext();
	const { memberIds } = useMemberIds(streamId);
	const members = useUserLookupArray(memberIds, streamId);
	const botMember = useMemo(() => {
		for (const member of members) if (member.isBot && member.appAddress) return {
			clientAddress: member.userId,
			appAddress: member.appAddress
		};
		return null;
	}, [members]);
	const isMemberDataLoading = enabled && !!streamId && memberIds.length === 0;
	const botDataQueryOptions = useMemo(() => createBotDataQueryOptions(botMember?.appAddress, townsEnv, appRegistryDapp, environmentId), [
		botMember?.appAddress,
		townsEnv,
		appRegistryDapp,
		environmentId
	]);
	const botDataResult = useQuery$1({
		...botDataQueryOptions,
		enabled: enabled && !!botMember
	});
	const botStatusQueryOptions = useMemo(() => createBotStatusQueryOptions(botMember?.clientAddress, townsEnv, environmentId), [
		botMember?.clientAddress,
		townsEnv,
		environmentId
	]);
	const botStatusResult = useQuery$1({
		...botStatusQueryOptions,
		enabled: enabled && !!botMember
	});
	return useMemo(() => {
		if (!botMember) return {
			data: [],
			isLoading: isMemberDataLoading,
			isError: false
		};
		const botData = botDataResult.data;
		const status = botStatusResult.data;
		const isStatusLoading = botStatusResult.isLoading;
		const isLoading = botDataResult.isLoading;
		if (!botData) return {
			data: [],
			isLoading,
			isError: botDataResult.isError
		};
		const slashCommands = botData.metadata?.slashCommands ?? [];
		if (slashCommands.length === 0) return {
			data: [],
			isLoading: false,
			isError: false
		};
		if (!isStatusLoading && status?.isActive === false) return {
			data: [],
			isLoading: false,
			isError: false
		};
		const data = [{
			appAddress: botMember.appAddress,
			appClientAddress: botMember.clientAddress,
			slashCommands,
			botName: botData.metadata?.displayName
		}];
		return {
			data,
			isLoading,
			isError: botDataResult.isError || botStatusResult.isError
		};
	}, [
		botMember,
		botDataResult,
		botStatusResult,
		isMemberDataLoading
	]);
};

//#endregion
//#region src/hooks/use-update-bot-pricing-transaction.ts
const useUpdateBotPricing = () => {
	const { baseTransactor } = useBaseWrites();
	const queryClient$1 = useQueryClient();
	return useTransaction({
		execute: async (params) => {
			return baseTransactor.updateAppPricing(params);
		},
		invalidateQueries: (params) => [blockchainKeys.botData(params.appAddress), blockchainKeys.myBots()],
		optimisticUpdate: { apply: (params) => {
			queryClient$1.setQueryData(blockchainKeys.botData(params.appAddress), (old) => old ? {
				...old,
				installPrice: params.installPrice,
				accessDuration: params.accessDuration
			} : old);
		} },
		debugName: "useUpdateBotPricing"
	});
};

//#endregion
//#region src/hooks/use-withdraw-app-funds-transaction.ts
const useWithdrawAppFunds = () => {
	const { baseTransactor } = useBaseWrites();
	return useTransaction({
		execute: async (params) => {
			return baseTransactor.withdrawAppFunds(params);
		},
		invalidateQueries: (params) => {
			const keys = [
				blockchainKeys.townsTokenBalance(params.recipient),
				blockchainKeys.townsTokenBalance(params.appAddress),
				["useBalance", params.recipient],
				["useBalance", params.appAddress]
			];
			if (params.currencyAddress) {
				keys.push([
					"usdcBalance",
					params.recipient,
					params.currencyAddress
				]);
				keys.push([
					"usdcBalance",
					params.appAddress,
					params.currencyAddress
				]);
			}
			return keys;
		},
		debugName: "useWithdrawAppFunds"
	});
};

//#endregion
//#region src/hooks/use-uninstall-app.ts
const useUninstallApp = () => {
	const { clientSingleton } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	return useTransaction({
		execute: async (params) => {
			return baseTransactor.uninstallApp(params);
		},
		invalidateQueries: (params) => {
			if (params.target === "space") return [blockchainKeys.accountInstalledApps(params.spaceAddress)];
			else if (params.target === "userAccount") return [blockchainKeys.accountInstalledApps(params.userAddress)];
			else return [];
		},
		onSuccess: async (params) => {
			if (params.target === "space" && params.appUserId) await clientSingleton?.removeUser(SpaceIdFromSpaceAddress(params.spaceAddress), params.appUserId);
		},
		debugName: "useUninstallAppTransaction"
	});
};

//#endregion
//#region src/hooks/use-update-app-permissions.ts
const useUpdateAppPermissionsTransaction = ({ onSuccess, onError }) => {
	const { baseTransactor } = useBaseWrites();
	const queryClient$1 = useQueryClient();
	const old = useRef(void 0);
	return useTransaction({
		execute: async (params) => {
			return baseTransactor.updateAppPermissions(params);
		},
		invalidateQueries: (params) => [blockchainKeys.botData(params.appAddress)],
		debugName: "useUpdateAppPermissionsTransaction",
		optimisticUpdate: {
			apply: (params) => {
				old.current = queryClient$1.getQueryData(blockchainKeys.botData(params.appAddress));
				queryClient$1.setQueryData(blockchainKeys.botData(params.appAddress), (old$1) => old$1 ? {
					...old$1,
					permissions: params.permissions
				} : old$1);
			},
			rollback: (params) => {
				queryClient$1.setQueryData(blockchainKeys.botData(params.appAddress), (optimisticOld) => optimisticOld ? {
					...optimisticOld,
					permissions: old.current?.permissions
				} : optimisticOld);
			}
		},
		onSuccess,
		onError
	});
};

//#endregion
//#region src/hooks/use-update-app.ts
const useUpdateAppTransaction = ({ onSuccess, onError }) => {
	const { baseTransactor } = useBaseWrites();
	const { lookupUser } = useUserLookupContext();
	const { setSpaceUser } = useUserLookupStore();
	const oldAppId = useRef(void 0);
	return useTransaction({
		execute: async (params) => {
			return baseTransactor.updateApp(params);
		},
		invalidateQueries: (params) => [blockchainKeys.accountInstalledApps(params.spaceAddress)],
		optimisticUpdate: {
			apply: (params) => {
				const bot = lookupUser(params.clientAddress);
				if (bot) {
					oldAppId.current = bot.appId;
					setSpaceUser(params.clientAddress, {
						...bot,
						appId: params.latestAppId
					}, SpaceIdFromSpaceAddress(params.spaceAddress));
				}
			},
			rollback: (params) => {
				const bot = lookupUser(params.clientAddress);
				if (bot && oldAppId.current !== void 0) setSpaceUser(params.clientAddress, {
					...bot,
					appId: oldAppId.current
				}, SpaceIdFromSpaceAddress(params.spaceAddress));
			}
		},
		debugName: "useUpdateAppTransaction",
		onSuccess,
		onError
	});
};

//#endregion
//#region src/hooks/use-renew-app.ts
const ONE_YEAR_IN_SECONDS = 31557600;
const useRenewAppTransaction = ({ onSuccess, onError } = {}) => {
	const { clientSingleton } = useTownsClient();
	const { baseTransactor } = useBaseWrites();
	const qc = useQueryClient$1();
	const previousValue = useRef(void 0);
	return useTransaction({
		execute: async (params) => {
			if (!clientSingleton) throw new Error("Client not initialized");
			return baseTransactor.renewApp(params);
		},
		invalidateQueries: (params) => [blockchainKeys.accountInstalledApps(params.spaceAddress), blockchainKeys.appExpiration(SpaceIdFromSpaceAddress(params.spaceAddress), params.appAddress)],
		optimisticUpdate: {
			apply: (params) => {
				const queryKey = blockchainKeys.appExpiration(SpaceIdFromSpaceAddress(params.spaceAddress), params.appAddress);
				const old = BigInt(qc.getQueryData(queryKey) ?? 0);
				if (old !== void 0) {
					previousValue.current = BigInt(old);
					const oneYearInSeconds = BigInt(ONE_YEAR_IN_SECONDS);
					qc.setQueryData(queryKey, old + oneYearInSeconds);
				}
			},
			rollback: (params) => {
				if (previousValue.current !== void 0) qc.setQueryData(blockchainKeys.appExpiration(SpaceIdFromSpaceAddress(params.spaceAddress), params.appAddress), previousValue.current);
			}
		},
		debugName: "useRenewAppTransaction",
		onSuccess,
		onError
	});
};

//#endregion
export { AT_CHANNEL_MENTION, AT_CHANNEL_MENTION_DISPLAY, AuthStatus, BaseReadsProvider, BaseTransactor, BaseWritesContext, BaseWritesProvider, BlockchainTransactionType, ChannelContext, ChannelContextProvider, CreateSpaceFlowStatus, DMChannelContextUserLookupProvider, HOUR_MS, JoinFlowStatus, MINIAPP_COMMAND_PREFIX, MINUTE_MS, MembershipAlreadyMemberError, MembershipRejectedError, MiniappActionSchema, MiniappEmbedSchema, NULL_ADDRESS, QueryProvider, SECOND_MS, SignerUndefinedError, SpaceContext, SpaceContextProvider, TownsContext, TownsContextProvider, TransactionStatus, WalletDoesNotMatchSignedInAccountError, WalletStatus, addCategoryToError, addCategoryToErrorIfNotExists, blockchainKeys as blockchainQueryKeys, bustMembershipStatus, calculateMinAmountBase, chunkSize, createAgentPromotionStatusQueryOptions, createBaseReadsContext, createBotDataQueryOptions, createBotStatusQueryOptions, decryptAESGCM, encryptAESGCM, encryptChunkedAESGCM, extractTransferAmountFromLogs, fetchGuardianStatus, fetchMembershipStatus, generateApproveAmountCallData, generateOfflineUserKey, getAppExpiration, getBannedWalletAddresses, getChainName, getChannelPermissionOverrides, getChannelSettings, getChannelSettingsQueryData, getETHInputAmountAfterFees, getErrorCategory, getInstalledApps, getMembershipFreeAllocation, getMembershipInfo, getMembershipInfoQueryData, getMembershipPrice, getMultipleRoleDetails, getPermissionsByRoleId, getPlatformMembershipFee, getPlatformMembershipFeeFromQueryCache, getPlatformMinMembershipPrice, getPlatformMinMembershipPriceFromQueryCache, getPlatformMintLimit, getPricingModuleQueryData, getPricingModules, getProtocolFee, getRiverPoints, getRoleDetails, getRoleDetailsQueryData, getRoles, getRootKeyFromLinkedWalletCached, getSafeOfflineMembershipStatus, getSingleSubscription, getSpaceDelegationOperator, getSpaceDelegationsByOperator, getSpaceInfo, getSpaceInfoQueryData, getSpaceOwner, getSpaceTips, getStakingDepositDetails, getStakingDepositsByOwner, getStakingRewards, getSubscriptions, getSwapsPaginated, getTokenIdOfOwner, getTownsTokenBalance, invalidateGuardianStatus, invalidateHasPermissionQueriesForSpace, invalidateSpaceInfoQuery, invalidateSpaceOwner, invariant, isMembershipExpired, isMentionedTextMessageOptions, isMiniappCommand, isNullAddress, isThreadIdOptions, isUpdateChannelAccessInfo, makeProviderFromChain, makeProviderFromConfig, parseMiniappCommand, primaryWalletStore, queryClient, retryOperation, signMessageAbortController, signMessageAbortListener, skipErrorDecoding, sleep, sleepUntil, staleTime24Hours, staticAssertNever, toError, toMessageInfo, toRoomIdentifier, useActivateOrInstallSubscription, useAddSpaceDelegationTransaction, useAgentFeedbackSummary, useAgentPromotionStatus, useAppBadge, useAppsInChannel, useBanTransaction, useBannedWalletAddresses, useBaseReads, useBaseWrites, useBlockedUsers, useBotChannels, useBotData, useBotInstalledIn, useBotStatus, useBotStatusArray, useBotStatusPrefetch, useBotsByOwner, useCasablancaCredentials, useCasablancaStore, useChannelContext, useChannelData, useChannelId, useChannelMembers, useChannelNotificationCounts, useChannelSettings, useChannelSlashCommands, useChannelThread, useChannelThreadStat, useChannelTimeline, useChannelWithId, useCheckInTransaction, useChunkedMedia, useClaimAndIncreaseStakeToTownTransaction, useClaimAndStakeToTownTransaction, useClaimRewardTransaction, useClearChannelPermissionOverrides, useConnectivity, useContractSpaceInfo, useContractSpaceInfoWithoutClient, useCreateAppTransaction, useCreateChannelTransaction, useCreateRoleTransaction, useCreateSpaceTransaction, useDMData, useDMLatestMessage, useDMSlashCommands, useDebugDeps, useDefaultOwnershipCooldown, useDeleteRoleTransaction, useDepositsDelegation, useDepositsUnlockDate, useDisableGuardian, useDmSettings, useDmsAndGdms, useDmsAndGdmsUnreads, useDownloadFile, useEditSpaceMembershipTransaction, useEnableGuardian, useFavIconBadge, useFetchHasJoinPermission, useFullyReadMarker, useGdmSettings, useGetRootKeyFromLinkedWallet, useGetSingleSubscription, useGetSubscriptions, useGiveBotFeedbackTransaction, useGuardianStatus, useHasPermission, useImageStore, useIncreaseStakeToTownTransaction, useInitiateWithdrawTransaction, useInstallAppOnUserAccountTransaction, useInstallAppTransaction, useInstallAppWithModuleTransaction, useInstalledApps, useIsSpaceOwner, useIsTransactionPending, useLinkCallerToRootKey, useLinkEOAToRootKeyTransaction, useLinkSmartAccountAndEOAAndSetDefaultWallet, useLinkedAndDelegatedWallets, useMemberIds, useMemberOf, useMembership, useMembershipFreeAllocation, useMembershipInfo, useMembershipInfoWithPricingModule, useMembershipPrice, useMembershipRenewalPrice, useMembershipStatus, useMessageReactions, useMessageThreadStats, useMessageTips, useMintMembershipTransaction, useMintThenJoin, useMultipleMembershipStatus, useMultipleRoleDetails, useMutationSpaceInfoCache, useMuteSettings, useMutedStreamIds, useMyChannels, useMyDefaultUsernames, useMyLinkedWallets, useMyMembership, useMyMemberships, useMyProfile, useMyUserId, useMyWallets, useNetworkStatus, useNotificationSettings, useNotificationSettingsData, useObservable, useObservableWith, useOfflineStore, useOnHasPermissionQueryUpdate, useOnTransactionUpdated, useOptimisticTipsStore, usePauseSubscription, usePermissionOverrides, usePins, usePlatformMembershipFee, usePlatformMembershipPriceForSupplyInEth, usePlatformMinMembershipPrice, usePlatformMintLimit, usePrefetchMultipleRoleDetails, usePricingModules, usePrimaryWallet, usePromoteAgentTransaction, useProtocolFee, useRankedTopStakingTowns, useRawTimelineStore, useReadAppExpiration, useRedelegateStakeTransaction, useRefreshMetadataTx, useRegisterAppTransaction, useRenewAppTransaction, useRenewMembership, useReviewTransaction, useRiverPoints, useRiverPointsCheckIn, useRiverPointsDetails, useRoleDetails, useRoles, useSanctionedAddresses, useSetChannelAutojoin, useSetChannelPermissionOverrides, useSetHideUserJoinLeave, useSetPrimaryWallet, useSpaceContext, useSpaceData, useSpaceDataStore, useSpaceDataWithId, useSpaceDelegationOperator, useSpaceDelegationsByOperator, useSpaceId, useSpaceLastAccessed, useSpaceMembers, useSpaceMembersWithFallback, useSpaceMentions, useSpaceNotificationCounts, useSpaceSettings, useSpaceThreadRoots, useSpaceThreadRootsUnreadCount, useSpaceTimeline, useSpaceTips, useSpaceUnread, useSpaceUnreadChannelMentions, useSpaceUnreadThreadMentions, useSpaceUnreads, useSpacesIds, useSpacesIdsFrom, useStakeToTownTransaction, useStakingDepositDetailsQueries, useStakingDepositsByOwnerQuery, useStakingRewardsQuery, useStreamEncryptionAlgorithm, useStreamMemberIds, useStreamMetadataUpdater, useStreamUpToDate, useSupportedXChainIds, useThrottledTimelineStore, useTimeline, useTimelineThread, useTimelineThreadStats, useTipTransaction, useTokenIdOfOwner, useTotalStakedByUser, useTownsClient, useTownsContext, useTownsTokenBalance, useTransaction, useTransactionStore, useTransferAssetTransaction, useTransferOwnership, useUnbanTransaction, useUninstallApp, useUnjoinedChannelMembers, useUnlinkViaCallerTransaction, useUnlinkWalletTransaction, useUpdateAppPermissionsTransaction, useUpdateAppTransaction, useUpdateBotPricing, useUpdateChannelTransaction, useUpdateRoleTransaction, useUpdateSpaceInfoTransaction, useUser, useUserLookup, useUserLookupArray, useUserLookupContext, useUserLookupMap, useUserLookupStore, useWalletAddressIsBanned, useWithdrawAppFunds, useWithdrawTransaction };
//# sourceMappingURL=index.js.map